// src/validations/auth.schema.ts
import { z } from "zod";
var loginSchema = z.object({
  email: z.string({ required_error: "login:validation.emailRequired" }).email("login:validation.invalidEmail"),
  password: z.string({ required_error: "login:validation.passwordRequired" }).min(8, "login:validation.passwordTooShort")
}).required();
var registerSchema = z.object({
  email: z.string().email("login:validation.invalidEmail"),
  password: z.string({ required_error: "common:validation.passwordRequired" }).min(8, "common:validation.passwordTooShort"),
  confirmPassword: z.string().min(8, "common:validation.confirmPasswordTooShort"),
  firstName: z.string({ required_error: "common:validation.firstNameRequired" }).min(1),
  lastName: z.string({ required_error: "common:validation.lastNameRequired" }).min(1),
  organizationName: z.string({
    required_error: "login:validation.organizationNameRequired"
  }).min(1)
}).required().refine((data) => data.password === data.confirmPassword, {
  message: "common:validation.passwordsDoNotMatch",
  path: ["confirmPassword"]
});
var acceptInvitationSchema = z.object({
  token: z.string().min(1, "login:validation.tokenRequired"),
  firstName: z.string().min(1, "common:validation.firstNameRequired"),
  lastName: z.string().min(1, "common:validation.lastNameRequired"),
  password: z.string().min(8, "common:validation.passwordTooShort"),
  confirmPassword: z.string().min(8, "common:validation.confirmPasswordTooShort")
}).required().refine((data) => data.password === data.confirmPassword, {
  message: "common:validation.passwordsDoNotMatch",
  path: ["confirmPassword"]
});
var refreshTokenSchema = z.object({
  refreshToken: z.string().min(1, "Refresh token is required")
});
var forgotPasswordSchema = z.object({
  email: z.string({ required_error: "login:validation.emailRequired" }).email("login:validation.invalidEmail"),
  locale: z.enum(["en", "de", "ba", "rs"]).optional()
});
var resetPasswordSchema = z.object({
  token: z.string().min(1, "login:validation.tokenRequired"),
  password: z.string({ required_error: "common:validation.passwordRequired" }).min(8, "common:validation.passwordTooShort"),
  confirmPassword: z.string().min(8, "common:validation.confirmPasswordTooShort")
}).required().refine((data) => data.password === data.confirmPassword, {
  message: "common:validation.passwordsDoNotMatch",
  path: ["confirmPassword"]
});

// src/validations/vehicles/trucks.schema.ts
import { z as z2 } from "zod";

// src/constants/countries.ts
var COUNTRY_CODES = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];

// src/types/vehicle.ts
var DEFAULT_MAX_AXLE_WEIGHT_KG = 11500;
var SERVICE_DUE_SOON_KM = 2e3;
var SERVICE_STALE_FACTOR = 3;
var FuelType = /* @__PURE__ */ ((FuelType2) => {
  FuelType2["Diesel"] = "diesel";
  FuelType2["Petrol"] = "petrol";
  FuelType2["Electric"] = "electric";
  FuelType2["Hybrid"] = "hybrid";
  return FuelType2;
})(FuelType || {});
var VehicleType = /* @__PURE__ */ ((VehicleType2) => {
  VehicleType2["Truck"] = "truck";
  VehicleType2["Bus"] = "bus";
  VehicleType2["Trailer"] = "trailer";
  return VehicleType2;
})(VehicleType || {});
var RouteVehicleProfile = /* @__PURE__ */ ((RouteVehicleProfile2) => {
  RouteVehicleProfile2["TruckAndTrailer40t"] = "truckAndTrailer40t";
  RouteVehicleProfile2["Truck11t"] = "truck11t";
  RouteVehicleProfile2["Truck7_5t"] = "truck7_5t";
  RouteVehicleProfile2["Bus"] = "bus";
  RouteVehicleProfile2["Transporter3_5t"] = "transporter3_5t";
  RouteVehicleProfile2["Car"] = "car";
  return RouteVehicleProfile2;
})(RouteVehicleProfile || {});
function routeTransportMode(profile) {
  switch (profile) {
    case "bus" /* Bus */:
      return "bus";
    case "transporter3_5t" /* Transporter3_5t */:
    case "car" /* Car */:
      return "car";
    default:
      return "truck";
  }
}
var VehicleStatus = /* @__PURE__ */ ((VehicleStatus2) => {
  VehicleStatus2["Active"] = "active";
  VehicleStatus2["Maintenance"] = "maintenance";
  VehicleStatus2["OutOfService"] = "out-of-service";
  return VehicleStatus2;
})(VehicleStatus || {});
var DisplayStatus = /* @__PURE__ */ ((DisplayStatus2) => {
  DisplayStatus2["Active"] = "active";
  DisplayStatus2["Idle"] = "idle";
  DisplayStatus2["Maintenance"] = "maintenance";
  DisplayStatus2["Off"] = "off";
  DisplayStatus2["OutOfService"] = "out-of-service";
  return DisplayStatus2;
})(DisplayStatus || {});
var TrailerType = /* @__PURE__ */ ((TrailerType2) => {
  TrailerType2["Tarpaulin"] = "tarpaulin";
  TrailerType2["NoTarpaulin"] = "no-tarpaulin";
  TrailerType2["Tanker"] = "tanker";
  TrailerType2["Refrigerated"] = "refrigerated";
  TrailerType2["Tipper"] = "tipper";
  TrailerType2["Flatbed"] = "flatbed";
  TrailerType2["Container"] = "container";
  return TrailerType2;
})(TrailerType || {});

// src/validations/vehicles/trucks.schema.ts
var addTruckSchema = z2.object({
  name: z2.string().optional(),
  licensePlate: z2.string().min(1, "common:validation.licensePlateRequired"),
  registrationCountry: z2.enum(COUNTRY_CODES, {
    errorMap: () => ({
      message: "common:validation.registrationCountryRequired"
    })
  }),
  vin: z2.string().min(1, "common:validation.vinRequired"),
  manufacturer: z2.string({ required_error: "common:validation.manufacturerRequired" }).min(1, "common:validation.manufacturerRequired"),
  adr: z2.boolean({
    required_error: "common:validation.adrRequired"
  }),
  customsBonds: z2.string().optional(),
  costCenter: z2.string().optional(),
  fuelType: z2.nativeEnum(FuelType, {
    required_error: "vehicles:validation.fuelTypeRequired"
  }).refine((value) => value !== "petrol" /* Petrol */, {
    message: "vehicles:validation.invalidFuelType"
  }),
  vehicleModel: z2.string().optional(),
  engineType: z2.string().optional(),
  kw: z2.number().optional(),
  horsePower: z2.number().optional(),
  axles: z2.coerce.number().min(2, "vehicles:validation.minTwoAxles"),
  // Optional per-vehicle override of the single-axle overload threshold (kg).
  // Empty → DEFAULT_MAX_AXLE_WEIGHT_KG (11.5 t legal ceiling) is used. Must be
  // positive: 0 would COALESCE as a real 0 kg limit → permanent overload alert.
  maxAxleWeightKg: z2.coerce.number().positive().optional(),
  // Optional per-vehicle service interval (km), compared against the count-up
  // telemetry `service_mileage`. Empty → no service-due alert for this vehicle.
  serviceIntervalKm: z2.coerce.number().int().positive().optional(),
  // Optional per-vehicle fuel tank capacity (liters). Converts the CAN
  // `fuel_level` percentage into liters for fuel-theft detection + euro
  // estimate. Empty → anomaly events recorded in percent only.
  tankCapacityLiters: z2.coerce.number().positive().optional(),
  notes: z2.string().optional(),
  // Optional Calculate Route profile preset for this vehicle. Empty → picking/
  // assigning the vehicle on a route won't auto-fill the route vehicle profile.
  routeProfile: z2.nativeEnum(RouteVehicleProfile).optional(),
  type: z2.nativeEnum(VehicleType, {
    required_error: "vehicles:validation.typeRequired"
  }),
  status: z2.nativeEnum(VehicleStatus, {
    required_error: "common:validation.statusRequired"
  }),
  active: z2.boolean({ required_error: "common:validation.activeRequired" }),
  trailerId: z2.string().optional(),
  vehicleRegistration: z2.instanceof(File).optional(),
  vehicleRegistrationExpiry: z2.coerce.date().optional(),
  technicalInspection: z2.instanceof(File).optional(),
  technicalInspectionExpiry: z2.coerce.date().optional(),
  vehicleInsurance: z2.instanceof(File).optional(),
  vehicleInsuranceExpiry: z2.coerce.date().optional(),
  tachographCalibration: z2.instanceof(File).optional(),
  tachographCalibrationExpiry: z2.coerce.date().optional(),
  speedLimiterCertificate: z2.instanceof(File).optional(),
  speedLimiterCertificateExpiry: z2.coerce.date().optional(),
  adrVehicleApproval: z2.instanceof(File).optional(),
  adrVehicleApprovalExpiry: z2.coerce.date().optional(),
  communityLicenseCopy: z2.instanceof(File).optional(),
  communityLicenseCopyExpiry: z2.coerce.date().optional(),
  emissionsCertificate: z2.instanceof(File).optional(),
  emissionsCertificateExpiry: z2.coerce.date().optional()
});
var editTruckSchema = addTruckSchema.omit({
  trailerId: true,
  vehicleRegistration: true,
  vehicleRegistrationExpiry: true,
  technicalInspection: true,
  technicalInspectionExpiry: true,
  vehicleInsurance: true,
  vehicleInsuranceExpiry: true,
  tachographCalibration: true,
  tachographCalibrationExpiry: true,
  speedLimiterCertificate: true,
  speedLimiterCertificateExpiry: true,
  adrVehicleApproval: true,
  adrVehicleApprovalExpiry: true,
  communityLicenseCopy: true,
  communityLicenseCopyExpiry: true,
  emissionsCertificate: true,
  emissionsCertificateExpiry: true
});

// src/validations/vehicles/trailer.schema.ts
import { z as z3 } from "zod";
var addTrailerSchema = z3.object({
  // Vehicle-level fields
  name: z3.string().optional(),
  vin: z3.string().min(1, "common:validation.vinRequired"),
  registrationCountry: z3.enum(COUNTRY_CODES, {
    errorMap: () => ({
      message: "common:validation.registrationCountryRequired"
    })
  }),
  licensePlate: z3.string().min(1, "common:validation.licensePlateRequired"),
  manufacturer: z3.string({ required_error: "common:validation.manufacturerRequired" }).min(1, "common:validation.manufacturerRequired"),
  axles: z3.coerce.number().min(1, "common:validation.axlesRequired"),
  notes: z3.string().optional(),
  status: z3.nativeEnum(VehicleStatus, {
    required_error: "common:validation.statusRequired"
  }),
  active: z3.boolean({ required_error: "common:validation.activeRequired" }),
  // Trailer-specific fields
  width: z3.coerce.number().min(0.1, "vehicles:validation.widthRequired"),
  height: z3.coerce.number().min(0.1, "vehicles:validation.heightRequired"),
  length: z3.coerce.number().min(0.1, "vehicles:validation.lengthRequired"),
  maxWeight: z3.coerce.number().min(0.1, "vehicles:validation.maxWeightRequired"),
  tires: z3.coerce.number().min(1, "vehicles:validation.tiresRequired"),
  type: z3.nativeEnum(TrailerType, {
    required_error: "vehicles:validation.trailerTypeRequired"
  }),
  vehicleRegistration: z3.instanceof(File).optional(),
  vehicleRegistrationExpiry: z3.coerce.date().optional(),
  technicalInspection: z3.instanceof(File).optional(),
  technicalInspectionExpiry: z3.coerce.date().optional(),
  vehicleInsurance: z3.instanceof(File).optional(),
  vehicleInsuranceExpiry: z3.coerce.date().optional(),
  adrVehicleApproval: z3.instanceof(File).optional(),
  adrVehicleApprovalExpiry: z3.coerce.date().optional()
});
var editTrailerSchema = addTrailerSchema.omit({
  vehicleRegistration: true,
  vehicleRegistrationExpiry: true,
  technicalInspection: true,
  technicalInspectionExpiry: true,
  vehicleInsurance: true,
  vehicleInsuranceExpiry: true,
  adrVehicleApproval: true,
  adrVehicleApprovalExpiry: true
});

// src/validations/drivers.schema.ts
import { z as z4 } from "zod";
var createDriverSchema = z4.object({
  firstName: z4.string().min(1, "common:validation.firstNameRequired"),
  lastName: z4.string().min(1, "common:validation.lastNameRequired"),
  email: z4.preprocess(
    (val) => val === "" ? void 0 : val,
    z4.string().email("drivers:validation.invalidEmail").optional()
  ),
  countryCode: z4.string({
    required_error: "drivers:validation.countryCodeRequired",
    invalid_type_error: "drivers:validation.countryCodeRequired"
  }).length(2, "drivers:validation.countryCodeRequired"),
  phone: z4.string({
    required_error: "drivers:validation.phoneRequired",
    invalid_type_error: "drivers:validation.phoneRequired"
  }).min(1, "drivers:validation.phoneRequired").regex(/^\d+$/, "drivers:validation.phoneDigitsOnly"),
  licenseNumber: z4.string().min(1, "drivers:validation.licenseNumberRequired"),
  tachographCardId: z4.string().min(1, "drivers:validation.tachographCardIdRequired"),
  tachographCardExpiry: z4.date({
    required_error: "drivers:validation.tachographCardExpiryRequired"
  }),
  licenseExpiry: z4.date({
    required_error: "drivers:validation.licenseExpiryRequired"
  }),
  passportNumber: z4.preprocess(
    (val) => val === "" ? void 0 : val,
    z4.string().min(1).optional()
  ),
  identityCardNumber: z4.preprocess(
    (val) => val === "" ? void 0 : val,
    z4.string().min(1).optional()
  ),
  experience: z4.preprocess(
    (val) => val === "" || val === void 0 || val === null ? void 0 : val,
    z4.coerce.number().min(1, "drivers:validation.experienceRequired").optional()
  ),
  vehicleId: z4.preprocess(
    (val) => {
      if (val === void 0 || val === null || val === "") return void 0;
      const n = Number(val);
      return Number.isNaN(n) ? void 0 : n;
    },
    z4.number({
      required_error: "drivers:validation.vehicleRequired",
      invalid_type_error: "drivers:validation.vehicleRequired"
    }).min(1, "drivers:validation.vehicleRequired")
  ),
  adr: z4.boolean({
    required_error: "common:validation.adrRequired"
  }).optional(),
  cpc: z4.boolean({
    required_error: "drivers:validation.cpcRequired"
  }).optional(),
  drivingLicense: z4.instanceof(File).optional(),
  drivingLicenseExpiry: z4.coerce.date().optional(),
  idCard: z4.instanceof(File).optional(),
  idCardExpiry: z4.coerce.date().optional(),
  drivingCard: z4.instanceof(File).optional(),
  drivingCardExpiry: z4.coerce.date().optional(),
  passport: z4.instanceof(File).optional(),
  passportExpiry: z4.coerce.date().optional(),
  workContract: z4.instanceof(File).optional(),
  workContractExpiry: z4.coerce.date().optional(),
  code95: z4.instanceof(File).optional(),
  code95Expiry: z4.coerce.date().optional(),
  adrCertificate: z4.instanceof(File).optional(),
  adrCertificateExpiry: z4.coerce.date().optional(),
  cpcCertificate: z4.instanceof(File).optional(),
  cpcCertificateExpiry: z4.coerce.date().optional()
});
var updateDriverSchema = z4.object({
  firstName: z4.string().min(1, "common:validation.firstNameRequired").optional(),
  lastName: z4.string().min(1, "common:validation.lastNameRequired").optional(),
  email: z4.preprocess(
    (val) => val === "" ? void 0 : val,
    z4.string().email("drivers:validation.invalidEmail").optional()
  ),
  countryCode: z4.string().length(2, "drivers:validation.countryCodeRequired").optional(),
  phone: z4.string().min(1, "drivers:validation.phoneRequired").regex(/^\d+$/, "drivers:validation.phoneDigitsOnly").optional(),
  licenseNumber: z4.string().min(1, "drivers:validation.licenseNumberRequired").optional(),
  tachographCardId: z4.string().min(1, "drivers:validation.tachographCardIdRequired").optional(),
  tachographCardExpiry: z4.date({
    required_error: "drivers:validation.tachographCardExpiryRequired"
  }).optional(),
  licenseExpiry: z4.date({
    required_error: "drivers:validation.licenseExpiryRequired"
  }).optional(),
  passportNumber: z4.preprocess(
    (val) => val === "" ? void 0 : val,
    z4.string().min(1).optional()
  ),
  identityCardNumber: z4.string().min(1, "drivers:validation.identityCardNumberRequired").optional(),
  experience: z4.coerce.number().min(1, "drivers:validation.experienceRequired").optional(),
  adr: z4.boolean({
    required_error: "common:validation.adrRequired"
  }).optional(),
  cpc: z4.boolean({
    required_error: "drivers:validation.cpcRequired"
  }).optional(),
  vehicleId: z4.union([
    z4.coerce.number().min(1, "drivers:validation.vehicleRequired"),
    z4.null()
  ]).optional()
});

// src/validations/documents.schema.ts
import { z as z5 } from "zod";

// src/types/document.ts
var DocumentEntityType = /* @__PURE__ */ ((DocumentEntityType2) => {
  DocumentEntityType2["Driver"] = "driver";
  DocumentEntityType2["Vehicle"] = "vehicle";
  DocumentEntityType2["Organization"] = "organization";
  DocumentEntityType2["Route"] = "route";
  return DocumentEntityType2;
})(DocumentEntityType || {});
var DocumentType = /* @__PURE__ */ ((DocumentType2) => {
  DocumentType2["DrivingLicense"] = "driving_license";
  DocumentType2["IdCard"] = "id_card";
  DocumentType2["DrivingCard"] = "driving_card";
  DocumentType2["Passport"] = "passport";
  DocumentType2["WorkContract"] = "work_contract";
  DocumentType2["Code95"] = "code_95";
  DocumentType2["AdrCertificate"] = "adr_certificate";
  DocumentType2["CpcCertificate"] = "cpc_certificate";
  DocumentType2["MedicalCertificate"] = "medical_certificate";
  DocumentType2["DriverAttestation"] = "driver_attestation";
  DocumentType2["VehicleRegistration"] = "vehicle_registration";
  DocumentType2["TechnicalInspection"] = "technical_inspection";
  DocumentType2["VehicleInsurance"] = "vehicle_insurance";
  DocumentType2["TachographCalibration"] = "tachograph_calibration";
  DocumentType2["SpeedLimiterCertificate"] = "speed_limiter_certificate";
  DocumentType2["AdrVehicleApproval"] = "adr_vehicle_approval";
  DocumentType2["CommunityLicenseCopy"] = "community_license_copy";
  DocumentType2["EmissionsCertificate"] = "emissions_certificate";
  DocumentType2["CommunityLicense"] = "community_license";
  DocumentType2["CmrInsurance"] = "cmr_insurance";
  DocumentType2["LiabilityInsurance"] = "liability_insurance";
  DocumentType2["OperatorLicense"] = "operator_license";
  DocumentType2["CompanyRegistration"] = "company_registration";
  DocumentType2["CmrNote"] = "cmr_note";
  DocumentType2["CustomsTransit"] = "customs_transit";
  DocumentType2["DangerousGoodsDocument"] = "dangerous_goods_document";
  DocumentType2["OversizePermit"] = "oversize_permit";
  DocumentType2["Other"] = "other";
  return DocumentType2;
})(DocumentType || {});
var DocumentStatus = /* @__PURE__ */ ((DocumentStatus2) => {
  DocumentStatus2["Valid"] = "valid";
  DocumentStatus2["Expired"] = "expired";
  DocumentStatus2["Pending"] = "pending";
  return DocumentStatus2;
})(DocumentStatus || {});
var DocumentExpiryFilter = /* @__PURE__ */ ((DocumentExpiryFilter2) => {
  DocumentExpiryFilter2["Valid"] = "valid";
  DocumentExpiryFilter2["ExpiringSoon"] = "expiring-soon";
  DocumentExpiryFilter2["Expired"] = "expired";
  return DocumentExpiryFilter2;
})(DocumentExpiryFilter || {});
var DOCUMENT_EXPIRY_SOON_DAYS = 30;
var ROADWORTHINESS_DOCUMENT_TYPES = [
  "vehicle_registration" /* VehicleRegistration */,
  "technical_inspection" /* TechnicalInspection */,
  "vehicle_insurance" /* VehicleInsurance */,
  "tachograph_calibration" /* TachographCalibration */
];
var DRIVER_DOCUMENT_FIELD_MAP = {
  drivingLicense: "driving_license" /* DrivingLicense */,
  idCard: "id_card" /* IdCard */,
  drivingCard: "driving_card" /* DrivingCard */,
  passport: "passport" /* Passport */,
  workContract: "work_contract" /* WorkContract */,
  code95: "code_95" /* Code95 */,
  adrCertificate: "adr_certificate" /* AdrCertificate */,
  cpcCertificate: "cpc_certificate" /* CpcCertificate */
};
var TRUCK_DOCUMENT_FIELD_MAP = {
  vehicleRegistration: "vehicle_registration" /* VehicleRegistration */,
  technicalInspection: "technical_inspection" /* TechnicalInspection */,
  vehicleInsurance: "vehicle_insurance" /* VehicleInsurance */,
  tachographCalibration: "tachograph_calibration" /* TachographCalibration */,
  speedLimiterCertificate: "speed_limiter_certificate" /* SpeedLimiterCertificate */,
  adrVehicleApproval: "adr_vehicle_approval" /* AdrVehicleApproval */,
  communityLicenseCopy: "community_license_copy" /* CommunityLicenseCopy */,
  emissionsCertificate: "emissions_certificate" /* EmissionsCertificate */
};
var TRAILER_DOCUMENT_FIELD_MAP = {
  vehicleRegistration: "vehicle_registration" /* VehicleRegistration */,
  technicalInspection: "technical_inspection" /* TechnicalInspection */,
  vehicleInsurance: "vehicle_insurance" /* VehicleInsurance */,
  adrVehicleApproval: "adr_vehicle_approval" /* AdrVehicleApproval */
};
var BUS_DOCUMENT_FIELD_MAP = {
  vehicleRegistration: "vehicle_registration" /* VehicleRegistration */,
  technicalInspection: "technical_inspection" /* TechnicalInspection */,
  vehicleInsurance: "vehicle_insurance" /* VehicleInsurance */,
  tachographCalibration: "tachograph_calibration" /* TachographCalibration */,
  speedLimiterCertificate: "speed_limiter_certificate" /* SpeedLimiterCertificate */,
  communityLicenseCopy: "community_license_copy" /* CommunityLicenseCopy */,
  emissionsCertificate: "emissions_certificate" /* EmissionsCertificate */
};
var ENTITY_DOCUMENT_TYPES = {
  ["driver" /* Driver */]: [
    "driving_license" /* DrivingLicense */,
    "id_card" /* IdCard */,
    "driving_card" /* DrivingCard */,
    "passport" /* Passport */,
    "work_contract" /* WorkContract */,
    "code_95" /* Code95 */,
    "adr_certificate" /* AdrCertificate */,
    "cpc_certificate" /* CpcCertificate */,
    "medical_certificate" /* MedicalCertificate */,
    "driver_attestation" /* DriverAttestation */
  ],
  ["vehicle" /* Vehicle */]: [
    "vehicle_registration" /* VehicleRegistration */,
    "technical_inspection" /* TechnicalInspection */,
    "vehicle_insurance" /* VehicleInsurance */,
    "tachograph_calibration" /* TachographCalibration */,
    "speed_limiter_certificate" /* SpeedLimiterCertificate */,
    "adr_vehicle_approval" /* AdrVehicleApproval */,
    "community_license_copy" /* CommunityLicenseCopy */,
    "emissions_certificate" /* EmissionsCertificate */
  ],
  ["organization" /* Organization */]: [
    "community_license" /* CommunityLicense */,
    "cmr_insurance" /* CmrInsurance */,
    "liability_insurance" /* LiabilityInsurance */,
    "operator_license" /* OperatorLicense */,
    "company_registration" /* CompanyRegistration */
  ],
  ["route" /* Route */]: [
    "cmr_note" /* CmrNote */,
    "customs_transit" /* CustomsTransit */,
    "dangerous_goods_document" /* DangerousGoodsDocument */,
    "oversize_permit" /* OversizePermit */
  ]
};

// src/validations/documents.schema.ts
var createDocumentSchema = z5.object({
  entityType: z5.nativeEnum(DocumentEntityType).optional(),
  entityId: z5.coerce.number().optional(),
  documentType: z5.nativeEnum(DocumentType).optional(),
  expiryDate: z5.coerce.date().optional(),
  tags: z5.array(z5.string()).default([])
});

// src/validations/routes.schema.ts
import { z as z6 } from "zod";

// src/types/route.ts
var RouteStatus = /* @__PURE__ */ ((RouteStatus2) => {
  RouteStatus2["Planned"] = "planned";
  RouteStatus2["InProgress"] = "in-progress";
  RouteStatus2["Completed"] = "completed";
  RouteStatus2["Delayed"] = "delayed";
  return RouteStatus2;
})(RouteStatus || {});
var CheckpointType = /* @__PURE__ */ ((CheckpointType2) => {
  CheckpointType2["Pickup"] = "pickup";
  CheckpointType2["Delivery"] = "delivery";
  CheckpointType2["Rest"] = "rest";
  CheckpointType2["Fuel"] = "fuel";
  CheckpointType2["Border"] = "border";
  CheckpointType2["Customs"] = "customs";
  CheckpointType2["Parking"] = "parking";
  CheckpointType2["Terminal"] = "terminal";
  CheckpointType2["Other"] = "other";
  return CheckpointType2;
})(CheckpointType || {});
var RouteStopStatus = /* @__PURE__ */ ((RouteStopStatus2) => {
  RouteStopStatus2["Pending"] = "pending";
  RouteStopStatus2["InProgress"] = "in-progress";
  RouteStopStatus2["Completed"] = "completed";
  RouteStopStatus2["Arrived"] = "arrived";
  return RouteStopStatus2;
})(RouteStopStatus || {});

// src/validations/routes.schema.ts
var routeStopSchema = z6.object({
  address: z6.string().min(1, "routes:validation.addressRequired"),
  lat: z6.coerce.number().optional(),
  lng: z6.coerce.number().optional(),
  checkpointType: z6.nativeEnum(CheckpointType, {
    required_error: "routes:validation.checkpointTypeRequired"
  }),
  scheduledTime: z6.coerce.date().optional(),
  notes: z6.string().optional()
});
var routeTollEntrySchema = z6.object({
  countryCode: z6.string(),
  tollSystem: z6.string(),
  price: z6.number(),
  currency: z6.string(),
  distance: z6.number()
});
var routeCalcSnapshotSchema = z6.object({
  totalDistance: z6.coerce.number().optional(),
  // meters
  estimatedDuration: z6.coerce.number().optional(),
  // seconds
  totalTollCost: z6.coerce.number().optional(),
  tollCurrency: z6.string().optional(),
  totalCost: z6.coerce.number().optional(),
  polylines: z6.array(z6.string()).optional(),
  tollsBreakdown: z6.array(routeTollEntrySchema).optional(),
  countries: z6.array(z6.string()).optional(),
  // ISO-2 of all traversed countries
  co2Kg: z6.coerce.number().optional()
  // FM-180 Phase 2 CO2 snapshot
});
var createRouteSchema = z6.object({
  name: z6.string().min(1, "routes:validation.nameRequired"),
  vehicleId: z6.coerce.number().nullish(),
  // Order = sequence; [0] = lead driver. Trucks: 1; buses: 2-4+.
  driverIds: z6.array(z6.coerce.number()).default([]),
  vehicleType: z6.string().min(1, "routes:validation.vehicleTypeRequired"),
  status: z6.nativeEnum(RouteStatus).default("planned" /* Planned */),
  startAddress: z6.string().min(1, "routes:validation.startAddressRequired"),
  startLat: z6.coerce.number().optional(),
  startLng: z6.coerce.number().optional(),
  // Origin's stop type (origin lives on the route row, not in `stops`).
  startCheckpointType: z6.nativeEnum(CheckpointType).default("pickup" /* Pickup */),
  startTime: z6.coerce.date({
    required_error: "routes:validation.startTimeRequired"
  }),
  startNotes: z6.string().optional(),
  startStopNotes: z6.string().optional(),
  considerTraffic: z6.boolean().default(false),
  avoidHighway: z6.boolean().default(false),
  avoidToll: z6.boolean().default(false),
  calculateAlternatives: z6.boolean().default(false),
  // Reuse flags (FM-226). isTemplate is checkbox-driven (always sent on save);
  // isFavorite is toggled ONLY via the /flags endpoint, so it's optional here —
  // omitting it from a save payload preserves the stored value (Drizzle skips
  // undefined) instead of clobbering it to false on every edit.
  isTemplate: z6.boolean().default(false),
  isFavorite: z6.boolean().optional(),
  stops: z6.array(routeStopSchema).default([]),
  // Vehicle profile (pre-filled from selected vehicle, editable) — snapshot
  totalLength: z6.coerce.number().min(0).default(16.5),
  vehicleHeight: z6.coerce.number().min(0).default(4),
  vehicleWidth: z6.coerce.number().min(0).default(2.55),
  grossWeight: z6.coerce.number().min(0).default(40),
  weightPerAxle: z6.coerce.number().min(0).default(8.5),
  speedCap: z6.coerce.number().min(0).default(90),
  vehicleAxles: z6.coerce.number().min(1).default(2),
  trailerAxles: z6.coerce.number().min(0).default(3),
  emissionType: z6.string().default("euro6"),
  shippedHazardousGoods: z6.array(z6.string()).default([]),
  // Cost
  vehicleCostPerKm: z6.coerce.number().min(0).default(0),
  currency: z6.string().default("EUR"),
  freightRate: z6.coerce.number().min(0).optional(),
  // revenue → FM-180 Phase 2 margin
  // Cargo (optional; UI later)
  cargoDescription: z6.string().optional(),
  cargoWeightKg: z6.coerce.number().min(0).optional(),
  customerName: z6.string().optional(),
  orderRef: z6.string().optional()
}).merge(routeCalcSnapshotSchema);
var updateRouteSchema = createRouteSchema.partial();
var calculateRouteFormSchema = createRouteSchema.omit({
  name: true,
  vehicleId: true,
  driverIds: true,
  status: true,
  startAddress: true,
  startLat: true,
  startLng: true,
  startNotes: true,
  startCheckpointType: true,
  isTemplate: true,
  isFavorite: true,
  cargoDescription: true,
  cargoWeightKg: true,
  customerName: true,
  orderRef: true,
  totalDistance: true,
  estimatedDuration: true,
  totalTollCost: true,
  tollCurrency: true,
  totalCost: true,
  polylines: true,
  tollsBreakdown: true,
  countries: true
}).extend({
  startTime: z6.coerce.date().optional(),
  stops: z6.array(routeStopSchema).min(2, "routes:validation.atLeastTwoStops")
});

// src/validations/ddd-parsed.schema.ts
import { z as z7 } from "zod";

// src/types/activity-state.ts
var DriverActivityState = /* @__PURE__ */ ((DriverActivityState2) => {
  DriverActivityState2[DriverActivityState2["Rest"] = 0] = "Rest";
  DriverActivityState2[DriverActivityState2["Available"] = 1] = "Available";
  DriverActivityState2[DriverActivityState2["Work"] = 2] = "Work";
  DriverActivityState2[DriverActivityState2["Driving"] = 3] = "Driving";
  return DriverActivityState2;
})(DriverActivityState || {});
function isDriverActivityState(value) {
  return value in DriverActivityState;
}
var TachoCanWorkState = /* @__PURE__ */ ((TachoCanWorkState2) => {
  TachoCanWorkState2[TachoCanWorkState2["Rest"] = 0] = "Rest";
  TachoCanWorkState2[TachoCanWorkState2["Available"] = 1] = "Available";
  TachoCanWorkState2[TachoCanWorkState2["Work"] = 2] = "Work";
  TachoCanWorkState2[TachoCanWorkState2["Driving"] = 3] = "Driving";
  TachoCanWorkState2[TachoCanWorkState2["Error"] = 6] = "Error";
  TachoCanWorkState2[TachoCanWorkState2["NotAvailable"] = 7] = "NotAvailable";
  return TachoCanWorkState2;
})(TachoCanWorkState || {});

// src/validations/ddd-parsed.schema.ts
var dddFileKindSchema = z7.enum(["vu", "card"]);
var dddGenerationSchema = z7.enum([
  "GEN1",
  "GEN2_V1",
  "GEN2_V2",
  "UNKNOWN"
]);
var dddSeveritySchema = z7.enum(["info", "warning", "error"]);
var dddSignatureStatusSchema = z7.enum([
  "VERIFIED",
  "DATA_SIGNATURE_INVALID",
  "CERTIFICATE_VERIFICATION_FAILED",
  "STATUS_UNSPECIFIED"
]);
var dddCertificateInfoSchema = z7.object({
  description: z7.string().nullable(),
  nationName: z7.string().nullable(),
  certificationAuthorityReference: z7.string().nullable(),
  certificateHolderReference: z7.string().nullable(),
  validFrom: z7.string().nullable(),
  validTo: z7.string().nullable()
});
var dddSignatureSchema = z7.object({
  status: dddSignatureStatusSchema,
  algorithm: z7.string().nullable(),
  signedAt: z7.string().nullable(),
  signerCertificate: dddCertificateInfoSchema.nullable(),
  rootCertificate: dddCertificateInfoSchema.nullable()
});
var dddMetaSchema = z7.object({
  kind: dddFileKindSchema,
  generation: dddGenerationSchema,
  downloadedAt: z7.string().nullable(),
  signatureValid: z7.boolean().nullable(),
  signature: dddSignatureSchema.nullable(),
  fileName: z7.string().nullable()
});
var dddVehicleInfoSchema = z7.object({
  vrn: z7.string().nullable(),
  vin: z7.string().nullable(),
  registrationNation: z7.string().nullable(),
  firstUseDate: z7.string().nullable()
});
var dddVuInfoSchema = z7.object({
  manufacturer: z7.string().nullable(),
  serialNumber: z7.string().nullable(),
  softwareVersion: z7.string().nullable(),
  manufacturerAddress: z7.string().nullable(),
  partNumber: z7.string().nullable().default(null),
  /** Serial number's month/year as "MM/YY" (Gen2; Gen1 often blank). */
  serialDate: z7.string().nullable().default(null),
  softwareInstalledAt: z7.string().nullable().default(null),
  manufacturedAt: z7.string().nullable().default(null),
  approvalNumber: z7.string().nullable().default(null)
});
var dddDriverCardInfoSchema = z7.object({
  cardNumber: z7.string().nullable(),
  holderFirstName: z7.string().nullable(),
  holderSurname: z7.string().nullable(),
  holderBirthDate: z7.string().nullable(),
  issuingMemberState: z7.string().nullable(),
  issuingAuthority: z7.string().nullable(),
  issueDate: z7.string().nullable(),
  validFrom: z7.string().nullable(),
  expiryDate: z7.string().nullable(),
  preferredLanguage: z7.string().nullable()
});
var dddPeriodSchema = z7.object({
  from: z7.string().nullable(),
  to: z7.string().nullable()
});
var dddActivityRecordSchema = z7.object({
  state: z7.nativeEnum(DriverActivityState),
  startTime: z7.string(),
  endTime: z7.string(),
  durationSeconds: z7.number().int().nonnegative(),
  slot: z7.number().int().min(0).max(1).nullable(),
  /**
   * Driver-card files only: set when the card was NOT inserted (Annex 1C card
   * status bit). 'manual' = activity entered by hand on re-insertion,
   * 'unknown' = nothing entered. Absent/null = card inserted or VU record.
   */
  cardWithdrawn: z7.enum(["manual", "unknown"]).nullable().optional()
});
var dddCardEventSchema = z7.object({
  eventTime: z7.string(),
  eventType: z7.enum(["inserted", "removed"]),
  cardNumber: z7.string().nullable(),
  slot: z7.number().int().min(0).max(1),
  vrn: z7.string().nullable(),
  /** Registration nation of `vrn` (tacho nation enum name, e.g. "BOSNIA_HERZEGOVINA"). */
  vrnNation: z7.string().nullable().default(null),
  /** Vehicle odometer at insertion/withdrawal (VU) or first/last use (card). */
  odometerKm: z7.number().nullable().default(null),
  /** Card holder "Surname Firstname" — VU card insertion records only. */
  holderName: z7.string().nullable().default(null)
});
var dddEventRecordSchema = z7.object({
  time: z7.string(),
  endTime: z7.string().nullable(),
  type: z7.string(),
  description: z7.string().nullable(),
  durationSeconds: z7.number().int().nonnegative().nullable(),
  vrn: z7.string().nullable(),
  severity: dddSeveritySchema,
  /** VU over-speeding records only (Annex 1C maxSpeedValue / averageSpeedValue). */
  maxSpeedKmh: z7.number().nonnegative().nullable().optional(),
  avgSpeedKmh: z7.number().nonnegative().nullable().optional()
});
var dddSpeedSampleSchema = z7.object({
  time: z7.string(),
  kmh: z7.number().nonnegative()
});
var dddCalibrationRecordSchema = z7.object({
  time: z7.string(),
  type: z7.string().nullable(),
  technicianName: z7.string().nullable(),
  workshopName: z7.string().nullable(),
  workshopAddress: z7.string().nullable(),
  vrn: z7.string().nullable(),
  vin: z7.string().nullable(),
  oldOdometerKm: z7.number().nullable(),
  newOdometerKm: z7.number().nullable(),
  wVehicleCharacteristicConstant: z7.number().nullable(),
  kConstantOfRecordingEquipment: z7.number().nullable(),
  lTyreCircumference: z7.number().nullable(),
  tyreSize: z7.string().nullable(),
  authorisedSpeed: z7.number().nullable(),
  workshopCardNumber: z7.string().nullable().default(null),
  /** Workshop card issuing nation (tacho enum name, already corrected). */
  workshopCardNation: z7.string().nullable().default(null),
  nextCalibrationDate: z7.string().nullable().default(null)
});
var dddPairedSensorSchema = z7.object({
  serialNumber: z7.string().nullable(),
  /** Serial number's month/year as "MM/YY". */
  serialDate: z7.string().nullable(),
  approvalNumber: z7.string().nullable(),
  pairedAt: z7.string().nullable()
});
var dddKnownCardSchema = z7.object({
  cardNumber: z7.string().nullable(),
  /** Tacho card type enum name, e.g. "DRIVER_CARD". */
  cardType: z7.string().nullable(),
  /** Issuing nation (tacho enum name, already corrected). */
  nation: z7.string().nullable(),
  itsConsent: z7.boolean().nullable()
});
var dddTechnicalSchema = z7.object({
  pairedSensors: z7.array(dddPairedSensorSchema),
  knownCards: z7.array(dddKnownCardSchema)
});
var dddPlaceRecordSchema = z7.object({
  time: z7.string(),
  country: z7.string().nullable(),
  region: z7.string().nullable(),
  entryType: z7.string().nullable(),
  odometerKm: z7.number().nullable()
});
var dddDailyDistanceSchema = z7.object({
  /** Calendar day, YYYY-MM-DD. */
  date: z7.string(),
  km: z7.number().nonnegative()
});
var dddSpecificConditionSchema = z7.object({
  time: z7.string(),
  /** tachograph-go SpecificConditionType, e.g. OUT_OF_SCOPE_BEGIN, FERRY_TRAIN_CROSSING_END. */
  type: z7.string()
});
var dddControlTypeSchema = z7.enum([
  "cardDownload",
  "vuDownload",
  "printing",
  "display",
  "calibrationCheck"
]);
var dddControlActivitySchema = z7.object({
  time: z7.string(),
  types: z7.array(dddControlTypeSchema),
  /** Control card number of the officer, 16 chars. */
  controlCardNumber: z7.string().nullable(),
  /** Issuing nation of the control card (tacho enum name). */
  controlCardNation: z7.string().nullable(),
  /** Vehicle the control was carried out in (driver cards only). */
  vrn: z7.string().nullable(),
  vrnNation: z7.string().nullable(),
  /** Period checked (downloaded, displayed or printed) — null when not set. */
  downloadFrom: z7.string().nullable(),
  downloadTo: z7.string().nullable()
});
var dddVuDownloadSchema = z7.object({
  time: z7.string(),
  cardNumber: z7.string().nullable(),
  /** COMPANY_CARD / WORKSHOP_CARD / … (tacho enum name). */
  cardType: z7.string().nullable(),
  cardNation: z7.string().nullable(),
  companyName: z7.string().nullable()
});
var dddVuCardSessionSchema = z7.object({
  /** Full 16-char card number (id + replacement + renewal index). */
  cardNumber: z7.string().nullable(),
  cardNation: z7.string().nullable(),
  /** "Surname Firstname". */
  holderName: z7.string().nullable(),
  /** 0 = driver slot, 1 = co-driver slot. */
  slot: z7.number().int().min(0).max(1),
  insertedAt: z7.string(),
  /** Null while the card was still inserted at download time. */
  withdrawnAt: z7.string().nullable(),
  odometerInKm: z7.number().nullable(),
  odometerOutKm: z7.number().nullable(),
  /** Vehicle the card was last withdrawn from before this insertion. */
  previousVrn: z7.string().nullable(),
  previousVrnNation: z7.string().nullable(),
  previousWithdrawnAt: z7.string().nullable(),
  /** The driver entered manual activities at this insertion. */
  manualEntry: z7.boolean()
});
var dddVuCompanyLockSchema = z7.object({
  lockIn: z7.string(),
  /** Null while the lock is still active. */
  lockOut: z7.string().nullable(),
  companyName: z7.string().nullable(),
  companyAddress: z7.string().nullable(),
  cardNumber: z7.string().nullable(),
  cardNation: z7.string().nullable()
});
var dddParsedFileSchema = z7.object({
  meta: dddMetaSchema,
  period: dddPeriodSchema,
  vehicle: dddVehicleInfoSchema.nullable(),
  vu: dddVuInfoSchema.nullable(),
  driverCard: dddDriverCardInfoSchema.nullable(),
  activities: z7.array(dddActivityRecordSchema),
  cardEvents: z7.array(dddCardEventSchema),
  events: z7.array(dddEventRecordSchema),
  faults: z7.array(dddEventRecordSchema),
  speedSamples: z7.array(dddSpeedSampleSchema),
  calibration: z7.array(dddCalibrationRecordSchema),
  places: z7.array(dddPlaceRecordSchema),
  dailyDistance: z7.array(dddDailyDistanceSchema).default([]),
  /** Out of scope / ferry-train crossing entries, oldest first. */
  specificConditions: z7.array(dddSpecificConditionSchema).default([]),
  /** Card: last recorded control (0 or 1 entries). VU: recent controls. */
  controlActivities: z7.array(dddControlActivitySchema).default([]),
  /** VU files only: company / workshop downloads, oldest first. */
  vuDownloads: z7.array(dddVuDownloadSchema).default([]),
  /** VU files only: card insertion → withdrawal sessions, oldest first. */
  vuCardSessions: z7.array(dddVuCardSessionSchema).default([]),
  /** VU files only: company lock-in periods, oldest first. */
  companyLocks: z7.array(dddVuCompanyLockSchema).default([]),
  /** VU files only: paired sensors and known cards. */
  technical: dddTechnicalSchema.default({ pairedSensors: [], knownCards: [] })
});

// src/validations/tacho-schedule.schema.ts
import { z as z8 } from "zod";

// src/types/tacho-schedule.ts
var ScheduleRepeat = /* @__PURE__ */ ((ScheduleRepeat2) => {
  ScheduleRepeat2["Daily"] = "Daily";
  ScheduleRepeat2["Weekly"] = "Weekly";
  ScheduleRepeat2["Biweekly"] = "Biweekly";
  ScheduleRepeat2["Every28Days"] = "Every28Days";
  ScheduleRepeat2["Monthly"] = "Monthly";
  ScheduleRepeat2["Custom"] = "Custom";
  return ScheduleRepeat2;
})(ScheduleRepeat || {});
var ScheduleFileType = /* @__PURE__ */ ((ScheduleFileType2) => {
  ScheduleFileType2["Overview"] = "Overview";
  ScheduleFileType2["EventsAndFaults"] = "EventsAndFaults";
  ScheduleFileType2["DetailedSpeed"] = "DetailedSpeed";
  ScheduleFileType2["TechnicalData"] = "TechnicalData";
  ScheduleFileType2["Activities"] = "Activities";
  return ScheduleFileType2;
})(ScheduleFileType || {});
var ScheduleEntityType = /* @__PURE__ */ ((ScheduleEntityType2) => {
  ScheduleEntityType2["Driver"] = "driver";
  ScheduleEntityType2["Vehicle"] = "vehicle";
  return ScheduleEntityType2;
})(ScheduleEntityType || {});
var DriverScope = /* @__PURE__ */ ((DriverScope2) => {
  DriverScope2[DriverScope2["None"] = 0] = "None";
  DriverScope2[DriverScope2["Driver1"] = 1] = "Driver1";
  DriverScope2[DriverScope2["Driver2"] = 2] = "Driver2";
  DriverScope2[DriverScope2["Both"] = 3] = "Both";
  return DriverScope2;
})(DriverScope || {});
var ScheduleApplyTarget = /* @__PURE__ */ ((ScheduleApplyTarget2) => {
  ScheduleApplyTarget2["Selected"] = "selected";
  ScheduleApplyTarget2["Filtered"] = "filtered";
  ScheduleApplyTarget2["All"] = "all";
  return ScheduleApplyTarget2;
})(ScheduleApplyTarget || {});
var ScheduleScopeType = /* @__PURE__ */ ((ScheduleScopeType2) => {
  ScheduleScopeType2[ScheduleScopeType2["Global"] = 0] = "Global";
  ScheduleScopeType2[ScheduleScopeType2["Quick"] = 1] = "Quick";
  ScheduleScopeType2[ScheduleScopeType2["Local"] = 2] = "Local";
  return ScheduleScopeType2;
})(ScheduleScopeType || {});
function scheduleRepeatToDays(repeat, customRepeat) {
  switch (repeat) {
    case "Daily" /* Daily */:
      return 1;
    case "Weekly" /* Weekly */:
      return 7;
    case "Biweekly" /* Biweekly */:
      return 14;
    case "Every28Days" /* Every28Days */:
      return 28;
    case "Monthly" /* Monthly */:
      return 31;
    case "Custom" /* Custom */:
      return customRepeat && customRepeat > 0 ? customRepeat : 1;
  }
}

// src/validations/tacho-schedule.schema.ts
function refineCustomRepeat(data, ctx) {
  if (data.repeat === "Custom" /* Custom */ && (!data.customRepeat || data.customRepeat <= 0)) {
    ctx.addIssue({
      code: z8.ZodIssueCode.custom,
      message: "tachographSchedules:validation.customRepeatRequired",
      path: ["customRepeat"]
    });
  }
}
var scheduleBaseFields = {
  name: z8.string().min(1, "tachographSchedules:validation.nameRequired"),
  repeat: z8.nativeEnum(ScheduleRepeat, {
    required_error: "tachographSchedules:validation.repeatRequired",
    invalid_type_error: "tachographSchedules:validation.repeatRequired"
  }),
  customRepeat: z8.coerce.number().int().positive().optional(),
  startDate: z8.coerce.date({
    required_error: "tachographSchedules:validation.startDateRequired",
    invalid_type_error: "tachographSchedules:validation.startDateRequired"
  }),
  // Global schedule + "apply to all child companies" toggle.
  global: z8.boolean().optional(),
  attachedToRoot: z8.boolean().optional(),
  inheritanceEnabled: z8.boolean().optional()
};
var vehicleFileTypesField = {
  fileTypes: z8.array(z8.nativeEnum(ScheduleFileType)).min(1, "tachographSchedules:validation.fileTypesRequired")
};
function refineStartNotPast(data, ctx) {
  if (data.startDate.getTime() < Date.now() - 6e4) {
    ctx.addIssue({
      code: z8.ZodIssueCode.custom,
      message: "tachographSchedules:validation.startDateNotPast",
      path: ["startDate"]
    });
  }
}
var createDriverScheduleSchema = z8.object(scheduleBaseFields).superRefine((data, ctx) => {
  refineCustomRepeat(data, ctx);
  refineStartNotPast(data, ctx);
});
var editDriverScheduleSchema = z8.object({ ...scheduleBaseFields, id: z8.string().min(1) }).superRefine(refineCustomRepeat);
var createVehicleScheduleSchema = z8.object({ ...scheduleBaseFields, ...vehicleFileTypesField }).superRefine((data, ctx) => {
  refineCustomRepeat(data, ctx);
  refineStartNotPast(data, ctx);
});
var editVehicleScheduleSchema = z8.object({
  ...scheduleBaseFields,
  ...vehicleFileTypesField,
  id: z8.string().min(1)
}).superRefine(refineCustomRepeat);
var applyScheduleSchema = z8.object({
  scheduleId: z8.string().min(1),
  // OUR internal vehicle/driver ids (from the selected/filtered rows). The backend
  // maps each to its TachoSync external id via synced file rows and rejects any id
  // that doesn't belong to the caller's organization.
  entityIds: z8.array(z8.coerce.number().int().positive()).min(1, "tachographSchedules:validation.entitiesRequired")
});
var applyToAllScheduleSchema = z8.object({
  scheduleId: z8.string().min(1)
});
var quickEntityIdsField = {
  entityIds: z8.array(z8.coerce.number().int().positive()).min(1, "tachographSchedules:validation.entitiesRequired")
};
var quickActivitiesField = {
  activities: z8.object({
    startDate: z8.coerce.date({
      required_error: "tachographSchedules:validation.startDateRequired",
      invalid_type_error: "tachographSchedules:validation.startDateRequired"
    }),
    endDate: z8.coerce.date({
      required_error: "tachographSchedules:validation.endDateRequired",
      invalid_type_error: "tachographSchedules:validation.endDateRequired"
    })
  })
};
var createQuickVehicleScheduleSchema = z8.object({
  ...quickEntityIdsField,
  ...vehicleFileTypesField,
  ...quickActivitiesField,
  driverScope: z8.nativeEnum(DriverScope)
}).superRefine((data, ctx) => {
  if (data.activities.endDate.getTime() < data.activities.startDate.getTime()) {
    ctx.addIssue({
      code: z8.ZodIssueCode.custom,
      message: "tachographSchedules:validation.dateRangeInvalid",
      path: ["activities", "endDate"]
    });
  }
});
var createQuickDriverScheduleSchema = z8.object({
  ...quickEntityIdsField
});

// src/validations/admin/organizations/create-organization.schema.ts
import { z as z9 } from "zod";

// src/types/plans.ts
var OrganizationPlan = /* @__PURE__ */ ((OrganizationPlan2) => {
  OrganizationPlan2["Pilot"] = "pilot";
  OrganizationPlan2["Pracenje"] = "pracenje";
  OrganizationPlan2["Kontrola"] = "kontrola";
  OrganizationPlan2["Komanda"] = "komanda";
  return OrganizationPlan2;
})(OrganizationPlan || {});
var AppFeature = /* @__PURE__ */ ((AppFeature2) => {
  AppFeature2["GpsLiveLocation"] = "gps_live_location";
  AppFeature2["LocationHistory"] = "location_history";
  AppFeature2["LocationSharing"] = "location_sharing";
  AppFeature2["VehicleTelematics"] = "vehicle_telematics";
  AppFeature2["RoutePlanning"] = "route_planning";
  AppFeature2["RouteManagement"] = "route_management";
  AppFeature2["RouteLiveTracking"] = "route_live_tracking";
  AppFeature2["Eta"] = "eta";
  AppFeature2["RoutePublicSharing"] = "route_public_sharing";
  AppFeature2["DriverWorksheetPdf"] = "driver_worksheet_pdf";
  AppFeature2["FleetAnalytics"] = "fleet_analytics";
  AppFeature2["FuelCostTracking"] = "fuel_cost_tracking";
  AppFeature2["DriverCardExpiry"] = "driver_card_expiry";
  AppFeature2["TrailerSensors"] = "trailer_sensors";
  AppFeature2["PreventiveMaintenance"] = "preventive_maintenance";
  AppFeature2["HosData"] = "hos_data";
  AppFeature2["HosLive"] = "hos_live";
  AppFeature2["HosCompliance"] = "hos_compliance";
  AppFeature2["HosEtaFeasibility"] = "hos_eta_feasibility";
  AppFeature2["DddDownload"] = "ddd_download";
  AppFeature2["DddFileViewer"] = "ddd_file_viewer";
  AppFeature2["DocumentsManagement"] = "documents_management";
  AppFeature2["FleetDirectorDashboard"] = "fleet_director_dashboard";
  AppFeature2["FuelTheftDetection"] = "fuel_theft_detection";
  AppFeature2["AxleOverloadDetection"] = "axle_overload_detection";
  AppFeature2["SpeedViolationDetection"] = "speed_violation_detection";
  AppFeature2["CanDashboardLights"] = "can_dashboard_lights";
  AppFeature2["RouteDocuments"] = "route_documents";
  AppFeature2["AdvancedAnalytics"] = "advanced_analytics";
  return AppFeature2;
})(AppFeature || {});
var PRACENJE_FEATURES = [
  "gps_live_location" /* GpsLiveLocation */,
  "location_history" /* LocationHistory */,
  "location_sharing" /* LocationSharing */
];
var KONTROLA_FEATURES = [
  ...PRACENJE_FEATURES,
  "vehicle_telematics" /* VehicleTelematics */,
  "route_planning" /* RoutePlanning */,
  "route_management" /* RouteManagement */,
  "route_live_tracking" /* RouteLiveTracking */,
  "eta" /* Eta */,
  "route_public_sharing" /* RoutePublicSharing */,
  "driver_worksheet_pdf" /* DriverWorksheetPdf */,
  "fleet_analytics" /* FleetAnalytics */,
  "fuel_cost_tracking" /* FuelCostTracking */,
  "driver_card_expiry" /* DriverCardExpiry */,
  "trailer_sensors" /* TrailerSensors */,
  "preventive_maintenance" /* PreventiveMaintenance */
];
var ALL_FEATURES = Object.values(AppFeature);
var PLAN_FEATURES = {
  ["pracenje" /* Pracenje */]: PRACENJE_FEATURES,
  ["kontrola" /* Kontrola */]: KONTROLA_FEATURES,
  ["komanda" /* Komanda */]: ALL_FEATURES,
  ["pilot" /* Pilot */]: ALL_FEATURES
};
function planHasFeature(plan, feature) {
  if (!plan) return false;
  return PLAN_FEATURES[plan].includes(feature);
}
var PLAN_ORDER = [
  "pracenje" /* Pracenje */,
  "kontrola" /* Kontrola */,
  "komanda" /* Komanda */
];
function minimumPlanForFeature(feature) {
  for (const plan of PLAN_ORDER) {
    if (PLAN_FEATURES[plan].includes(feature)) return plan;
  }
  return null;
}
function isPilotExpired(plan, pilotExpiresAt) {
  if (plan !== "pilot" /* Pilot */) return false;
  if (!pilotExpiresAt) return false;
  return /* @__PURE__ */ new Date() > new Date(pilotExpiresAt);
}

// src/types/user.ts
var OrganizationRoles = /* @__PURE__ */ ((OrganizationRoles2) => {
  OrganizationRoles2["OWNER"] = "owner";
  OrganizationRoles2["DISPATCHER"] = "dispatcher";
  OrganizationRoles2["DRIVER"] = "driver";
  OrganizationRoles2["MANAGER"] = "manager";
  return OrganizationRoles2;
})(OrganizationRoles || {});
var PlatformRole = /* @__PURE__ */ ((PlatformRole2) => {
  PlatformRole2["User"] = "user";
  PlatformRole2["SuperAdmin"] = "super_admin";
  PlatformRole2["Support"] = "support";
  return PlatformRole2;
})(PlatformRole || {});
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["Active"] = "active";
  UserStatus2["Disabled"] = "disabled";
  return UserStatus2;
})(UserStatus || {});
var OrganizationStatus = /* @__PURE__ */ ((OrganizationStatus2) => {
  OrganizationStatus2["Active"] = "active";
  OrganizationStatus2["Disabled"] = "disabled";
  return OrganizationStatus2;
})(OrganizationStatus || {});

// src/validations/admin/organizations/create-organization.schema.ts
var optionalString = z9.preprocess(
  (val) => val === "" || val === null ? void 0 : val,
  z9.string().optional()
);
var optionalEmail = z9.preprocess(
  (val) => val === "" || val === null ? void 0 : val,
  z9.string().email("admin:organizations.validation.invalidEmail").optional()
);
var optionalUrl = z9.preprocess(
  (val) => val === "" || val === null ? void 0 : val,
  z9.string().url("admin:organizations.validation.invalidUrl").optional()
);
var optionalCountry = z9.preprocess(
  (val) => val === "" || val === null ? void 0 : val,
  z9.string().length(2, "admin:organizations.validation.invalidCountry").optional()
);
var createAdminOrganizationSchema = z9.object({
  name: z9.string({ required_error: "admin:organizations.validation.nameRequired" }).min(1, "admin:organizations.validation.nameRequired").max(255),
  plan: z9.nativeEnum(OrganizationPlan, {
    required_error: "admin:organizations.validation.planRequired"
  }),
  timezone: z9.string().min(1).max(64).default("Europe/Sarajevo"),
  status: z9.nativeEnum(OrganizationStatus).default("active" /* Active */),
  contactEmail: optionalEmail,
  contactPhone: optionalString,
  addressLine: optionalString,
  city: optionalString,
  postalCode: optionalString,
  countryCode: optionalCountry,
  taxId: optionalString,
  registrationNumber: optionalString,
  website: optionalUrl,
  // TachoSync (Teltonika) integration. Manual override for the company this org
  // maps to; normally inferred from synced file rows, but must be set by hand
  // when an org's files span >1 TachoSync company (inference returns null then).
  tachosyncCompanyId: optionalString,
  tachosyncCompanyName: optionalString
});

// src/validations/admin/organizations/update-organization.schema.ts
var updateAdminOrganizationSchema = createAdminOrganizationSchema.partial();

// src/validations/admin/organizations/retention.schema.ts
import { z as z10 } from "zod";

// src/constants/retention.ts
var RETENTION_FILE_TYPES = ["ddd"];
var DDD_DEFAULT_RETENTION_MONTHS = 12;
var MIN_RETENTION_MONTHS = 12;
var MAX_RETENTION_MONTHS = 120;

// src/validations/admin/organizations/retention.schema.ts
var updateRetentionSchema = z10.object({
  fileType: z10.enum(RETENTION_FILE_TYPES),
  retentionMonths: z10.coerce.number().int("admin:organizations.retention.validation.invalid").min(
    MIN_RETENTION_MONTHS,
    "admin:organizations.retention.validation.tooShort"
  ).max(
    MAX_RETENTION_MONTHS,
    "admin:organizations.retention.validation.tooLong"
  )
});
var retentionResponseSchema = z10.object({
  ddd: z10.number().int()
});

// src/validations/admin/users/create-user.schema.ts
import { z as z11 } from "zod";
var createAdminUserSchema = z11.object({
  email: z11.string({ required_error: "admin:users.validation.emailRequired" }).email("admin:users.validation.invalidEmail"),
  firstName: z11.string({ required_error: "common:validation.firstNameRequired" }).min(1, "common:validation.firstNameRequired"),
  lastName: z11.string({ required_error: "common:validation.lastNameRequired" }).min(1, "common:validation.lastNameRequired"),
  phoneNumber: z11.preprocess(
    (val) => val === "" ? void 0 : val,
    z11.string().optional()
  ),
  password: z11.string({ required_error: "common:validation.passwordRequired" }).min(8, "common:validation.passwordTooShort"),
  platformRole: z11.nativeEnum(PlatformRole).default("user" /* User */),
  status: z11.nativeEnum(UserStatus).default("active" /* Active */),
  organizationId: z11.preprocess(
    (val) => {
      if (val === void 0 || val === null || val === "") return void 0;
      const n = Number(val);
      return Number.isNaN(n) ? void 0 : n;
    },
    z11.number().int().positive().optional()
  ),
  organizationRole: z11.nativeEnum(OrganizationRoles).optional()
});

// src/validations/admin/users/update-user.schema.ts
var updateAdminUserSchema = createAdminUserSchema.omit({ password: true }).partial();

// src/validations/admin/devices/create-device.schema.ts
import { z as z12 } from "zod";
var optionalInt = z12.preprocess(
  (val) => {
    if (val === void 0 || val === null || val === "") return void 0;
    const n = Number(val);
    return Number.isNaN(n) ? void 0 : n;
  },
  z12.number().int().positive().optional()
);
var optionalString2 = z12.preprocess(
  (val) => val === "" || val === null ? void 0 : val,
  z12.string().optional()
);
var createAdminDeviceSchema = z12.object({
  deviceIdent: z12.string({ required_error: "admin:devices.validation.deviceIdentRequired" }).min(1, "admin:devices.validation.deviceIdentRequired").max(20),
  name: optionalString2,
  organizationId: optionalInt,
  vehicleId: optionalInt
});

// src/validations/admin/devices/update-device.schema.ts
var updateAdminDeviceSchema = createAdminDeviceSchema.omit({ deviceIdent: true }).partial();

// src/validations/admin/impersonation.schema.ts
import { z as z13 } from "zod";
var startImpersonationSchema = z13.object({
  targetUserId: z13.number().int().positive(),
  reason: z13.string().trim().max(500).optional()
});

// src/validations/feedback.schema.ts
import { z as z14 } from "zod";

// src/types/feedback.ts
var FeedbackSentiment = /* @__PURE__ */ ((FeedbackSentiment2) => {
  FeedbackSentiment2["Positive"] = "positive";
  FeedbackSentiment2["Neutral"] = "neutral";
  FeedbackSentiment2["Negative"] = "negative";
  return FeedbackSentiment2;
})(FeedbackSentiment || {});
var FeedbackStatus = /* @__PURE__ */ ((FeedbackStatus2) => {
  FeedbackStatus2["New"] = "new";
  FeedbackStatus2["Triaged"] = "triaged";
  FeedbackStatus2["Resolved"] = "resolved";
  return FeedbackStatus2;
})(FeedbackStatus || {});
var FeedbackCategory = /* @__PURE__ */ ((FeedbackCategory2) => {
  FeedbackCategory2["Bug"] = "bug";
  FeedbackCategory2["Feature"] = "feature";
  FeedbackCategory2["Question"] = "question";
  FeedbackCategory2["Other"] = "other";
  return FeedbackCategory2;
})(FeedbackCategory || {});

// src/validations/feedback.schema.ts
var FEEDBACK_MESSAGE_MAX_LENGTH = 2e3;
var FEEDBACK_METADATA_MAX_LENGTH = 500;
var createFeedbackSchema = z14.object({
  sentiment: z14.nativeEnum(FeedbackSentiment).optional(),
  category: z14.nativeEnum(FeedbackCategory).optional(),
  message: z14.string().trim().min(1).max(FEEDBACK_MESSAGE_MAX_LENGTH),
  pageUrl: z14.string().max(FEEDBACK_METADATA_MAX_LENGTH).optional(),
  userAgent: z14.string().max(FEEDBACK_METADATA_MAX_LENGTH).optional()
});

// src/types/driver.ts
var DriverStatus = /* @__PURE__ */ ((DriverStatus2) => {
  DriverStatus2["Available"] = "available";
  DriverStatus2["Driving"] = "driving";
  DriverStatus2["Resting"] = "resting";
  DriverStatus2["OffDuty"] = "off-duty";
  return DriverStatus2;
})(DriverStatus || {});

// src/types/error.ts
var UniqueConstraintError = /* @__PURE__ */ ((UniqueConstraintError2) => {
  UniqueConstraintError2["LicensePlateExists"] = "LICENSE_PLATE_EXISTS";
  UniqueConstraintError2["VinExists"] = "VIN_EXISTS";
  UniqueConstraintError2["LicenseNumberExists"] = "LICENSE_NUMBER_EXISTS";
  UniqueConstraintError2["TachographCardExists"] = "TACHOGRAPH_CARD_EXISTS";
  UniqueConstraintError2["PassportNumberExists"] = "PASSPORT_NUMBER_EXISTS";
  UniqueConstraintError2["IdentityCardExists"] = "IDENTITY_CARD_EXISTS";
  UniqueConstraintError2["EmailExists"] = "EMAIL_EXISTS";
  UniqueConstraintError2["DeviceIdentExists"] = "DEVICE_IDENT_EXISTS";
  UniqueConstraintError2["VehicleRouteInProgress"] = "VEHICLE_ROUTE_IN_PROGRESS";
  return UniqueConstraintError2;
})(UniqueConstraintError || {});

// src/types/indicator.ts
var IndicatorState = /* @__PURE__ */ ((IndicatorState2) => {
  IndicatorState2["Off"] = "Off";
  IndicatorState2["Info"] = "Info";
  IndicatorState2["Yellow"] = "Yellow";
  IndicatorState2["Red"] = "Red";
  return IndicatorState2;
})(IndicatorState || {});
var IndicatorType = /* @__PURE__ */ ((IndicatorType2) => {
  IndicatorType2["AdBlueLevel"] = "adblueLevel";
  IndicatorType2["AirFilterClogged"] = "airFilterClogged";
  IndicatorType2["Airbag"] = "airbag";
  IndicatorType2["BatteryCharging"] = "batteryCharging";
  IndicatorType2["BrakeFailure"] = "brakeFailure";
  IndicatorType2["BrakeLights"] = "brakeLights";
  IndicatorType2["DisabledPersons"] = "disabledPersons";
  IndicatorType2["Ebs"] = "ebs";
  IndicatorType2["EbsTrailer"] = "ebsTrailer";
  IndicatorType2["EngineCompartmentTemperature"] = "engineCompartmentTemperature";
  IndicatorType2["EngineMil"] = "engineMil";
  IndicatorType2["EngineOil"] = "engineOil";
  IndicatorType2["EngineOilLevel"] = "engineOilLevel";
  IndicatorType2["EngineOilTemperature"] = "engineOilTemperature";
  IndicatorType2["Esc"] = "esc";
  IndicatorType2["HatchOpen"] = "hatchOpen";
  IndicatorType2["HazardWarning"] = "hazardWarning";
  IndicatorType2["Kneeling"] = "kneeling";
  IndicatorType2["LowBeam"] = "lowBeam";
  IndicatorType2["Lowering"] = "lowering";
  IndicatorType2["ParkHeating"] = "parkHeating";
  IndicatorType2["PositionLights"] = "positionLights";
  IndicatorType2["Raising"] = "raising";
  IndicatorType2["RearFogLight"] = "rearFogLight";
  IndicatorType2["SeatBelt"] = "seatBelt";
  IndicatorType2["TireFailure"] = "tireFailure";
  IndicatorType2["TrailerConnected"] = "trailerConnected";
  IndicatorType2["TransmissionFailure"] = "transmissionFailure";
  IndicatorType2["TransmissionFluidTemperature"] = "transmissionFluidTemperature";
  IndicatorType2["TurnSignals"] = "turnSignals";
  IndicatorType2["WindscreenWasherFluid"] = "windscreenWasherFluid";
  IndicatorType2["WornBrakeLinings"] = "wornBrakeLinings";
  return IndicatorType2;
})(IndicatorType || {});
var IndicatorSeverity = /* @__PURE__ */ ((IndicatorSeverity2) => {
  IndicatorSeverity2[IndicatorSeverity2["Off"] = 0] = "Off";
  IndicatorSeverity2[IndicatorSeverity2["Info"] = 1] = "Info";
  IndicatorSeverity2[IndicatorSeverity2["Yellow"] = 2] = "Yellow";
  IndicatorSeverity2[IndicatorSeverity2["Red"] = 3] = "Red";
  return IndicatorSeverity2;
})(IndicatorSeverity || {});
var INDICATOR_FIELD_MAP = {
  "can.adblue.level.indicator.state": "adblueLevel" /* AdBlueLevel */,
  "can.air.filter.clogged.indicator.state": "airFilterClogged" /* AirFilterClogged */,
  "can.airbag.indicator.state": "airbag" /* Airbag */,
  "can.battery.charging.indicator.state": "batteryCharging" /* BatteryCharging */,
  "can.brake.failure.indicator.state": "brakeFailure" /* BrakeFailure */,
  "can.brake.lights.indicator.state": "brakeLights" /* BrakeLights */,
  "can.disabled.persons.indicator.state": "disabledPersons" /* DisabledPersons */,
  "can.ebs.indicator.state": "ebs" /* Ebs */,
  "can.ebs.trailer.indicator.state": "ebsTrailer" /* EbsTrailer */,
  "can.engine.compartment.temperature.indicator.state": "engineCompartmentTemperature" /* EngineCompartmentTemperature */,
  "can.engine.mil.indicator.state": "engineMil" /* EngineMil */,
  "can.engine.oil.indicator.state": "engineOil" /* EngineOil */,
  "can.engine.oil.level.indicator.state": "engineOilLevel" /* EngineOilLevel */,
  "can.engine.oil.temperature.indicator.state": "engineOilTemperature" /* EngineOilTemperature */,
  "can.esc.indicator.state": "esc" /* Esc */,
  "can.hatch.open.indicator.state": "hatchOpen" /* HatchOpen */,
  "can.hazard.warning.indicator.state": "hazardWarning" /* HazardWarning */,
  "can.kneeling.indicator.state": "kneeling" /* Kneeling */,
  "can.low.beam.indicator.state": "lowBeam" /* LowBeam */,
  "can.lowering.indicator.state": "lowering" /* Lowering */,
  "can.park.heating.indicator.state": "parkHeating" /* ParkHeating */,
  "can.position.lights.indicator.state": "positionLights" /* PositionLights */,
  "can.raising.indicator.state": "raising" /* Raising */,
  "can.rear.fog.light.indicator.state": "rearFogLight" /* RearFogLight */,
  "can.seat.belt.indicator.state": "seatBelt" /* SeatBelt */,
  "can.tire.failure.indicator.state": "tireFailure" /* TireFailure */,
  "can.trailer.connected.indicator.state": "trailerConnected" /* TrailerConnected */,
  "can.transmission.failure.indicator.state": "transmissionFailure" /* TransmissionFailure */,
  "can.transmission.fluid.temperature.indicator.state": "transmissionFluidTemperature" /* TransmissionFluidTemperature */,
  "can.turn.signals.indicator.state": "turnSignals" /* TurnSignals */,
  "can.windscreen.washer.fluid.indicator.state": "windscreenWasherFluid" /* WindscreenWasherFluid */,
  "can.worn.brake.linings.indicator.state": "wornBrakeLinings" /* WornBrakeLinings */
};
var ALL_INDICATOR_TYPES = Object.values(
  IndicatorType
);
var indicatorStateToSeverity = (state) => {
  switch (state) {
    case "Off" /* Off */:
      return 0 /* Off */;
    case "Info" /* Info */:
      return 1 /* Info */;
    case "Yellow" /* Yellow */:
      return 2 /* Yellow */;
    case "Red" /* Red */:
      return 3 /* Red */;
  }
};
var isIndicatorState = (value) => value === "Off" /* Off */ || value === "Info" /* Info */ || value === "Yellow" /* Yellow */ || value === "Red" /* Red */;
var HEALTH_FAULT_INDICATORS = /* @__PURE__ */ new Set([
  "adblueLevel" /* AdBlueLevel */,
  "airFilterClogged" /* AirFilterClogged */,
  "airbag" /* Airbag */,
  "batteryCharging" /* BatteryCharging */,
  "brakeFailure" /* BrakeFailure */,
  "ebs" /* Ebs */,
  "ebsTrailer" /* EbsTrailer */,
  "engineCompartmentTemperature" /* EngineCompartmentTemperature */,
  "engineMil" /* EngineMil */,
  "engineOil" /* EngineOil */,
  "engineOilLevel" /* EngineOilLevel */,
  "engineOilTemperature" /* EngineOilTemperature */,
  "esc" /* Esc */,
  "tireFailure" /* TireFailure */,
  "transmissionFailure" /* TransmissionFailure */,
  "transmissionFluidTemperature" /* TransmissionFluidTemperature */,
  "wornBrakeLinings" /* WornBrakeLinings */
]);
var isHealthFault = (type) => HEALTH_FAULT_INDICATORS.has(type);

// src/types/infringement.ts
var InfringementType = /* @__PURE__ */ ((InfringementType2) => {
  InfringementType2["ContinuousDrivingExceeded"] = "continuous_driving_exceeded";
  InfringementType2["DailyDrivingExceeded"] = "daily_driving_exceeded";
  InfringementType2["WeeklyDrivingExceeded"] = "weekly_driving_exceeded";
  InfringementType2["BiweeklyDrivingExceeded"] = "biweekly_driving_exceeded";
  InfringementType2["InsufficientDailyRest"] = "insufficient_daily_rest";
  InfringementType2["WeeklyRestOverdue"] = "weekly_rest_overdue";
  InfringementType2["CompensationOverdue"] = "compensation_overdue";
  InfringementType2["NightWorkExceeded"] = "night_work_exceeded";
  InfringementType2["WorkBreakExceeded"] = "work_break_exceeded";
  InfringementType2["UnknownPeriods"] = "unknown_periods";
  return InfringementType2;
})(InfringementType || {});
var InfringementSeverity = /* @__PURE__ */ ((InfringementSeverity2) => {
  InfringementSeverity2["Warning"] = "warning";
  InfringementSeverity2["Serious"] = "serious";
  InfringementSeverity2["VerySeriousIndividual"] = "very_serious_individual";
  InfringementSeverity2["VerySeriousCompany"] = "very_serious_company";
  return InfringementSeverity2;
})(InfringementSeverity || {});
var INFRINGEMENT_SEVERITY_MAP = {
  ["continuous_driving_exceeded" /* ContinuousDrivingExceeded */]: "serious" /* Serious */,
  ["daily_driving_exceeded" /* DailyDrivingExceeded */]: "very_serious_individual" /* VerySeriousIndividual */,
  ["weekly_driving_exceeded" /* WeeklyDrivingExceeded */]: "very_serious_individual" /* VerySeriousIndividual */,
  ["biweekly_driving_exceeded" /* BiweeklyDrivingExceeded */]: "very_serious_individual" /* VerySeriousIndividual */,
  ["insufficient_daily_rest" /* InsufficientDailyRest */]: "serious" /* Serious */,
  ["weekly_rest_overdue" /* WeeklyRestOverdue */]: "serious" /* Serious */,
  ["compensation_overdue" /* CompensationOverdue */]: "serious" /* Serious */,
  ["night_work_exceeded" /* NightWorkExceeded */]: "serious" /* Serious */,
  ["work_break_exceeded" /* WorkBreakExceeded */]: "serious" /* Serious */,
  ["unknown_periods" /* UnknownPeriods */]: "warning" /* Warning */
};

// src/types/tacho-roster.ts
var TachoDownloadStatus = /* @__PURE__ */ ((TachoDownloadStatus2) => {
  TachoDownloadStatus2["OnTime"] = "OnTime";
  TachoDownloadStatus2["DueSoon"] = "DueSoon";
  TachoDownloadStatus2["Overdue"] = "Overdue";
  TachoDownloadStatus2["NoDownloads"] = "NoDownloads";
  return TachoDownloadStatus2;
})(TachoDownloadStatus || {});
var TachoDeviceStatus = /* @__PURE__ */ ((TachoDeviceStatus2) => {
  TachoDeviceStatus2["Online"] = "Online";
  TachoDeviceStatus2["Offline"] = "Offline";
  return TachoDeviceStatus2;
})(TachoDeviceStatus || {});
var VEHICLE_DOWNLOAD_MAX_DAYS = 90;
var DRIVER_CARD_DOWNLOAD_MAX_DAYS = 28;
var DUE_SOON_WINDOW_DAYS = 7;
var DEVICE_ONLINE_THRESHOLD_MINUTES = 15;
var DAY_MS = 24 * 60 * 60 * 1e3;
function deriveDownloadStatus(lastDownloadAt, cadenceDays, now = /* @__PURE__ */ new Date()) {
  if (lastDownloadAt === null) {
    return "NoDownloads" /* NoDownloads */;
  }
  const lastMs = typeof lastDownloadAt === "string" ? new Date(lastDownloadAt).getTime() : lastDownloadAt.getTime();
  const dueMs = lastMs + cadenceDays * DAY_MS;
  const windowDays = Math.max(
    0,
    Math.min(DUE_SOON_WINDOW_DAYS, cadenceDays - 1)
  );
  const nowMs = now.getTime();
  if (nowMs > dueMs) {
    return "Overdue" /* Overdue */;
  }
  if (nowMs > dueMs - windowDays * DAY_MS) {
    return "DueSoon" /* DueSoon */;
  }
  return "OnTime" /* OnTime */;
}

// src/types/impersonation.ts
var ImpersonationSessionStatus = /* @__PURE__ */ ((ImpersonationSessionStatus2) => {
  ImpersonationSessionStatus2["Active"] = "active";
  ImpersonationSessionStatus2["Expired"] = "expired";
  ImpersonationSessionStatus2["Stopped"] = "stopped";
  return ImpersonationSessionStatus2;
})(ImpersonationSessionStatus || {});
var IMPERSONATION_HEADER = "x-impersonate-session";
var IMPERSONATION_MAX_DURATION_MS = 60 * 60 * 1e3;

// src/types/analytics.ts
var AnalyticsPeriod = /* @__PURE__ */ ((AnalyticsPeriod2) => {
  AnalyticsPeriod2["Week"] = "week";
  AnalyticsPeriod2["Month"] = "month";
  AnalyticsPeriod2["LastMonth"] = "lastMonth";
  return AnalyticsPeriod2;
})(AnalyticsPeriod || {});

// src/constants/fuel-anomaly.ts
var FUEL_ANOMALY_FEED_DAYS = 7;

// src/utils/country.ts
var APP_LOCALE_TO_COUNTRY_LOCALE = {
  en: "en",
  de: "de",
  ba: "bs",
  rs: "sr"
};
var REGIONAL_INDICATOR_A = 127462;
var LETTER_A = "A".charCodeAt(0);
function isoToFlag(code) {
  if (code.length !== 2) return "";
  const upper = code.toUpperCase();
  const first = upper.charCodeAt(0);
  const second = upper.charCodeAt(1);
  if (first < LETTER_A || first > LETTER_A + 25) return "";
  if (second < LETTER_A || second > LETTER_A + 25) return "";
  return String.fromCodePoint(
    REGIONAL_INDICATOR_A + first - LETTER_A,
    REGIONAL_INDICATOR_A + second - LETTER_A
  );
}

// src/utils/hos-eta.ts
var MIN = 60;
var HOUR = 60 * MIN;
var HOS_ETA = {
  /** Mandatory break after 4.5h continuous driving. */
  BREAK_SEC: 45 * MIN,
  /** Continuous driving allowed before a break. */
  CONTINUOUS_CAP_SEC: 4.5 * HOUR,
  /** Regular daily rest. */
  DAILY_REST_SEC: 11 * HOUR,
  /** Regular weekly rest. */
  WEEKLY_REST_SEC: 45 * HOUR,
  /** Reduced weekly rest (24h) — lower clamp for the device weekly-minimum field. */
  REDUCED_WEEKLY_REST_SEC: 24 * HOUR,
  /**
   * Art. 8(6): a new weekly rest must START within 6×24h of the previous one
   * ending. Shared so the API (weekly-rest-due gate) and the web countdown use
   * the same number instead of re-hardcoding 6×24h on each side.
   */
  WEEKLY_REST_DUE_AFTER_SEC: 6 * 24 * HOUR,
  /** Regular daily driving limit. */
  DAILY_DRIVING_CAP_SEC: 9 * HOUR,
  /** Extended daily driving limit (max twice per week). */
  DAILY_DRIVING_EXTENDED_SEC: 10 * HOUR,
  /** Art. 6(1): the 10h daily-driving extension is allowed at most twice/week. */
  DAILY_DRIVING_EXTENSIONS_PER_WEEK: 2,
  /** Reduced daily rest — also the threshold for "is this in-progress rest a daily rest". */
  REDUCED_DAILY_REST_SEC: 9 * HOUR,
  /** Weekly driving limit. */
  WEEKLY_DRIVING_CAP_SEC: 56 * HOUR,
  /**
   * Remaining-weekly values above this (60h, exceeds the legal 56h cap) are a
   * tachograph "no data" sentinel — treat the weekly limit as unknown.
   */
  WEEKLY_SENTINEL_MAX_SEC: 60 * HOUR
};
var clampPositive = (n, fallback) => n == null || !Number.isFinite(n) ? fallback : Math.max(0, n);
var inBand = (v, lo, hi) => v != null && Number.isFinite(v) && v >= lo && v <= hi;
var clampWeeklyRestSec = (deviceMin) => inBand(deviceMin, HOS_ETA.REDUCED_WEEKLY_REST_SEC, HOS_ETA.WEEKLY_REST_SEC) ? deviceMin : HOS_ETA.WEEKLY_REST_SEC;
var clampDailyRestSec = (deviceMin) => inBand(deviceMin, HOS_ETA.REDUCED_DAILY_REST_SEC, HOS_ETA.DAILY_REST_SEC) ? deviceMin : HOS_ETA.DAILY_REST_SEC;
function calculateHosAwareEta(input) {
  const legs = Array.isArray(input.drivingSeconds) ? input.drivingSeconds : [input.drivingSeconds];
  const drivingSec = legs.reduce(
    (sum, leg) => sum + (Number.isFinite(leg) ? Math.max(0, leg) : 0),
    0
  );
  if (!input.hos) {
    const arrivalMs = input.departureMs + drivingSec * 1e3;
    return {
      arrivalMs,
      drivingSec,
      restSec: 0,
      breakCount: 0,
      restCount: 0,
      segments: drivingSec ? [
        {
          type: "drive",
          durationSec: drivingSec,
          startMs: input.departureMs,
          endMs: arrivalMs
        }
      ] : [],
      hosKnown: false
    };
  }
  const hos = input.hos;
  const contCap = HOS_ETA.CONTINUOUS_CAP_SEC;
  const weeklyCap = HOS_ETA.WEEKLY_DRIVING_CAP_SEC;
  const dailyRestDur = clampDailyRestSec(hos.dailyMinimumRestSec);
  const firstWeeklyRestDur = clampWeeklyRestSec(hos.weeklyMinimumRestSec);
  let injectedWeeklyRests = 0;
  const extensionAvailable = hos.tenHourExtensionAvailableToday === true;
  let extendedDaysLeft = extensionAvailable ? Math.max(
    0,
    HOS_ETA.DAILY_DRIVING_EXTENSIONS_PER_WEEK - clampPositive(hos.extendedDrivingDaysUsed, 0)
  ) : 0;
  const nextDailyCap = () => {
    if (extendedDaysLeft > 0) {
      extendedDaysLeft -= 1;
      return HOS_ETA.DAILY_DRIVING_EXTENDED_SEC;
    }
    return HOS_ETA.DAILY_DRIVING_CAP_SEC;
  };
  const initialDailyCap = extensionAvailable ? HOS_ETA.DAILY_DRIVING_EXTENDED_SEC : HOS_ETA.DAILY_DRIVING_CAP_SEC;
  let cont = clampPositive(hos.remainingContinuousDriving, contCap);
  let daily = clampPositive(hos.remainingDailyDriving, initialDailyCap);
  if (daily > HOS_ETA.DAILY_DRIVING_CAP_SEC && extendedDaysLeft > 0) {
    extendedDaysLeft -= 1;
  }
  const weeklyRaw = hos.remainingWeeklyDriving;
  let weekly = weeklyRaw == null || !Number.isFinite(weeklyRaw) || weeklyRaw > HOS_ETA.WEEKLY_SENTINEL_MAX_SEC ? Number.POSITIVE_INFINITY : Math.max(0, weeklyRaw);
  const segments = [];
  let t = input.departureMs;
  const push = (type, durationSec) => {
    const startMs = t;
    const endMs = t + durationSec * 1e3;
    segments.push({ type, durationSec, startMs, endMs });
    t = endMs;
  };
  if (hos.isResting) {
    if (hos.currentRestIsWeekly) {
      const weeklyLeft = clampPositive(hos.currentRestRemainingSec, 0);
      if (weeklyLeft > 0) push("initial_rest", weeklyLeft);
      cont = contCap;
      weekly = weeklyCap;
      extendedDaysLeft = HOS_ETA.DAILY_DRIVING_EXTENSIONS_PER_WEEK;
      daily = nextDailyCap();
    } else {
      const restLeft = clampPositive(hos.remainingCurrentRest, 0);
      if (restLeft > 0) push("initial_rest", restLeft);
      cont = contCap;
      if (restLeft >= HOS_ETA.REDUCED_DAILY_REST_SEC) {
        daily = nextDailyCap();
      }
    }
  }
  let remaining = drivingSec;
  let guard = 0;
  while (remaining > 0 && guard++ < 1e4) {
    const block = Math.min(remaining, cont, daily, weekly);
    if (block > 0) {
      push("drive", block);
      remaining -= block;
      cont -= block;
      daily -= block;
      weekly -= block;
      if (remaining <= 0) break;
    }
    if (weekly <= 0) {
      const weeklyRestDur = injectedWeeklyRests === 0 ? firstWeeklyRestDur : HOS_ETA.WEEKLY_REST_SEC;
      injectedWeeklyRests += 1;
      push("weekly_rest", weeklyRestDur);
      weekly = weeklyCap;
      extendedDaysLeft = HOS_ETA.DAILY_DRIVING_EXTENSIONS_PER_WEEK;
      daily = nextDailyCap();
      cont = contCap;
    } else if (daily <= 0) {
      push("daily_rest", dailyRestDur);
      daily = nextDailyCap();
      cont = contCap;
    } else if (cont <= 0) {
      push("break", HOS_ETA.BREAK_SEC);
      cont = contCap;
    }
  }
  if (remaining > 0) push("drive", remaining);
  const restSec = segments.filter((s) => s.type !== "drive").reduce((sum, s) => sum + s.durationSec, 0);
  const breakCount = segments.filter((s) => s.type === "break").length;
  const restCount = segments.filter(
    (s) => s.type === "daily_rest" || s.type === "weekly_rest"
  ).length;
  return {
    arrivalMs: t,
    drivingSec,
    restSec,
    breakCount,
    restCount,
    segments,
    hosKnown: true
  };
}

// src/utils/driver-hos-from-tacho.ts
var clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n));
function driverHosFromTachoRemaining(row) {
  const tenHourLeft = row.remainingTenHourDrivingTimes;
  const tenHourKnown = tenHourLeft != null && Number.isFinite(tenHourLeft);
  return {
    remainingContinuousDriving: row.remainingContinuousDriving,
    remainingDailyDriving: row.remainingDailyDriving,
    remainingWeeklyDriving: row.remainingWeeklyDriving,
    tenHourExtensionAvailableToday: tenHourKnown ? tenHourLeft > 0 : null,
    extendedDrivingDaysUsed: tenHourKnown ? clamp(
      HOS_ETA.DAILY_DRIVING_EXTENSIONS_PER_WEEK - tenHourLeft,
      0,
      HOS_ETA.DAILY_DRIVING_EXTENSIONS_PER_WEEK
    ) : null,
    dailyMinimumRestSec: row.dailyMinimumRest,
    weeklyMinimumRestSec: row.weeklyMinimumRest
  };
}

// src/utils/route-hos-feasibility.ts
function assessRouteHosFeasibility(eta) {
  if (!eta.hosKnown) {
    return {
      status: "neutral",
      reason: "hos_unknown",
      restCount: 0,
      weeklyHit: false,
      regime: "EU561"
    };
  }
  const firstDailyRest = eta.segments.find((s) => s.type === "daily_rest");
  const firstWeeklyRest = eta.segments.find((s) => s.type === "weekly_rest");
  const weeklyHit = firstWeeklyRest != null;
  const status = weeklyHit ? "breach" : eta.restCount > 0 ? "caution" : "ok";
  return {
    status,
    firstDailyRestMs: firstDailyRest?.startMs,
    firstWeeklyRestMs: firstWeeklyRest?.startMs,
    restCount: eta.restCount,
    weeklyHit,
    regime: "EU561"
  };
}
var neutral = (reason) => ({
  status: "neutral",
  reason,
  restCount: 0,
  weeklyHit: false,
  regime: "EU561"
});
function buildRouteHosFeasibility(params) {
  const { driverCount, estimatedDuration, departureMs, hos } = params;
  if (driverCount === 0) return null;
  if (driverCount >= 2) return neutral("multi_manning");
  if (!estimatedDuration || estimatedDuration <= 0) {
    return neutral("not_calculated");
  }
  const eta = calculateHosAwareEta({
    drivingSeconds: estimatedDuration,
    departureMs,
    hos
  });
  return assessRouteHosFeasibility(eta);
}

// src/utils/rest-stop-planner.ts
var HOS_REST_NOTE_PREFIX = "[hos-rest:";
var SEARCH_RADII_M = {
  break: [15e3, 3e4],
  daily_rest: [15e3, 3e4, 6e4],
  weekly_rest: [15e3, 3e4, 6e4]
};
var MAX_NEARBY_HINTS = 3;
var MAX_ITERATIONS = 12;
function parkingVehicleClass(profile) {
  switch (profile) {
    case "bus":
      return "bus";
    case "truck7_5t":
      return "light_truck";
    case "transporter3_5t":
    case "car":
      return "van";
    default:
      return "heavy_truck";
  }
}
var DEG2RAD = Math.PI / 180;
var EARTH_M = 6371e3;
function haversineMeters(a, b) {
  const dLat = (b.lat - a.lat) * DEG2RAD;
  const dLng = (b.lng - a.lng) * DEG2RAD;
  const sinLat = Math.sin(dLat / 2);
  const sinLng = Math.sin(dLng / 2);
  const h = sinLat * sinLat + Math.cos(a.lat * DEG2RAD) * Math.cos(b.lat * DEG2RAD) * sinLng * sinLng;
  return EARTH_M * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
}
function positionAtDrivingTime(geometry, elapsedDrivingSec) {
  const sections = geometry.sections;
  if (sections.length === 0) {
    return { lat: 0, lng: 0, sectionIndex: 0, cumulativeDistanceM: 0 };
  }
  const first = sections[0]?.points[0];
  if (elapsedDrivingSec <= 0) {
    return {
      lat: first?.lat ?? 0,
      lng: first?.lng ?? 0,
      sectionIndex: 0,
      cumulativeDistanceM: 0
    };
  }
  let cumTime = 0;
  let cumDistBeforeSection = 0;
  for (let s = 0; s < sections.length; s++) {
    const section = sections[s];
    if (!section) continue;
    const fitsInSection = section.durationS > 0 && elapsedDrivingSec <= cumTime + section.durationS;
    if (fitsInSection || s === sections.length - 1) {
      const residual = Math.max(0, elapsedDrivingSec - cumTime);
      const fraction = section.durationS > 0 ? Math.min(1, residual / section.durationS) : 1;
      const targetDist = fraction * section.lengthM;
      const point = pointAtDistanceInSection(section, targetDist);
      return {
        lat: point.lat,
        lng: point.lng,
        sectionIndex: s,
        cumulativeDistanceM: cumDistBeforeSection + point.distanceIntoSectionM
      };
    }
    cumTime += section.durationS;
    cumDistBeforeSection += section.lengthM;
  }
  const lastSection = sections[sections.length - 1];
  const last = lastSection?.points[lastSection.points.length - 1];
  return {
    lat: last?.lat ?? 0,
    lng: last?.lng ?? 0,
    sectionIndex: sections.length - 1,
    cumulativeDistanceM: cumDistBeforeSection
  };
}
function pointAtDistanceInSection(section, targetDist) {
  const pts = section.points;
  const firstPt = pts[0];
  if (!firstPt) return { lat: 0, lng: 0, distanceIntoSectionM: 0 };
  if (pts.length === 1 || targetDist <= 0) {
    return { lat: firstPt.lat, lng: firstPt.lng, distanceIntoSectionM: 0 };
  }
  let walked = 0;
  for (let i = 1; i < pts.length; i++) {
    const prev = pts[i - 1];
    const curr = pts[i];
    if (!prev || !curr) continue;
    const segLen = haversineMeters(prev, curr);
    if (walked + segLen >= targetDist) {
      const f = segLen > 0 ? (targetDist - walked) / segLen : 0;
      return {
        lat: prev.lat + (curr.lat - prev.lat) * f,
        lng: prev.lng + (curr.lng - prev.lng) * f,
        distanceIntoSectionM: targetDist
      };
    }
    walked += segLen;
  }
  const last = pts[pts.length - 1];
  return {
    lat: last?.lat ?? firstPt.lat,
    lng: last?.lng ?? firstPt.lng,
    distanceIntoSectionM: walked
  };
}
function nearestCumulativeDistance(geometry, point) {
  let best = Infinity;
  let bestCum = 0;
  let cum = 0;
  for (const section of geometry.sections) {
    const pts = section.points;
    for (let i = 0; i < pts.length; i++) {
      const p = pts[i];
      if (!p) continue;
      const d = haversineMeters(p, point);
      if (d < best) {
        best = d;
        bestCum = cum;
      }
      const next = pts[i + 1];
      if (next) cum += haversineMeters(p, next);
    }
  }
  return bestCum;
}
function parkingQuality(a, kind, vehicleClass) {
  if (vehicleClass === "van") return "good";
  if (a.secure || a.restArea || a.hasFuel) return "good";
  if (vehicleClass === "bus") {
    return a.busStation && kind === "break" ? "good" : "weak";
  }
  if (a.truckParking) return "good";
  return vehicleClass === "light_truck" && kind === "break" ? "good" : "weak";
}
function scoreParking(c, kind, detourM, vehicleClass = "heavy_truck") {
  const a = c.attributes;
  const certified = (a.secure ? 1e3 : 0) + // certified secure (FM-240)
  (a.fenced ? 400 : 0) + // certified (FM-240)
  (a.lit ? 150 : 0);
  if (vehicleClass === "bus") {
    if (kind === "break") {
      return (a.restArea || a.hasFuel ? 500 : 0) + (a.busStation ? 300 : 0) - detourM;
    }
    return certified + (a.restArea ? 300 : 0) + (a.hasFuel ? 250 : 0) - 0.02 * detourM;
  }
  if (vehicleClass === "van") {
    const services = (a.restArea ? 200 : 0) + (a.hasFuel ? 100 : 0);
    return kind === "break" ? services - detourM : services - 0.02 * detourM;
  }
  if (kind === "break") {
    const bonus = a.restArea || a.truckParking ? 500 : 0;
    return bonus - detourM;
  }
  return certified + (a.truckParking ? 300 : 0) + // real truck parking — strongest HERE signal
  (a.restArea ? 200 : 0) + // motorway service area
  (a.hasFuel ? 100 : 0) - 0.02 * detourM;
}
function restSegmentsWithDriving(eta) {
  const out = [];
  let drivingSoFar = 0;
  for (const seg of eta.segments) {
    if (seg.type === "drive") {
      drivingSoFar += seg.durationSec;
    } else if (seg.type === "break" || seg.type === "daily_rest" || seg.type === "weekly_rest") {
      out.push({
        kind: seg.type,
        segment: seg,
        elapsedDrivingSec: drivingSoFar
      });
    }
  }
  return out;
}
async function planSecureParkingRests(input, deps) {
  const { baseGeometry, baseDrivingSeconds, departureMs, hos, existingVia } = input;
  const vehicleClass = input.vehicleClass ?? "heavy_truck";
  const baseEta = calculateHosAwareEta({
    drivingSeconds: baseDrivingSeconds,
    departureMs,
    hos
  });
  if (!baseEta.hosKnown) {
    return {
      rests: [],
      finalGeometry: baseGeometry,
      finalDrivingSeconds: baseDrivingSeconds,
      finalArrivalMs: baseEta.arrivalMs,
      feasibility: assessRouteHosFeasibility(baseEta),
      skipped: { reason: "hos_unknown" },
      reroutes: 0
    };
  }
  const placed = [];
  const insertedVia = [];
  let geometry = baseGeometry;
  let drivingSeconds = baseDrivingSeconds;
  let reroutes = 0;
  let iterations = 0;
  let currentEta = baseEta;
  let restList = restSegmentsWithDriving(currentEta);
  while (placed.length < restList.length && iterations < MAX_ITERATIONS) {
    iterations++;
    const ordinal = placed.length;
    const rest = restList[ordinal];
    if (!rest) break;
    const target = positionAtDrivingTime(geometry, rest.elapsedDrivingSec);
    const targetPoint = { lat: target.lat, lng: target.lng };
    const { good, weak } = await findCandidates(
      deps.findParking,
      targetPoint,
      rest.kind,
      vehicleClass
    );
    if (good.length === 0) {
      const annotated = annotatedRest(
        rest.kind,
        targetPoint,
        weak.length > 0 ? "low_confidence" : "no_parking_found",
        rest.segment
      );
      if (weak.length > 0) {
        annotated.nearbyCandidates = nearestHints(weak, targetPoint);
      }
      placed.push(annotated);
      continue;
    }
    const best = pickBest(good, rest.kind, targetPoint, vehicleClass);
    insertedVia.push({ lat: best.lat, lng: best.lng });
    const via = orderedVia(existingVia, insertedVia, geometry);
    reroutes++;
    const recalc = await deps.recalcRoute(via);
    geometry = recalc.geometry;
    drivingSeconds = recalc.drivingSeconds;
    placed.push({
      kind: rest.kind,
      lat: best.lat,
      lng: best.lng,
      label: best.label,
      attributes: best.attributes,
      arrivalAtParkingMs: rest.segment.startMs,
      restDurationSec: rest.segment.durationSec,
      departFromParkingMs: rest.segment.endMs,
      placement: "rerouted"
    });
    currentEta = calculateHosAwareEta({ drivingSeconds, departureMs, hos });
    restList = restSegmentsWithDriving(currentEta);
  }
  const finalEta = currentEta;
  const finalRests = restList;
  for (let i = 0; i < placed.length && i < finalRests.length; i++) {
    const p = placed[i];
    const fr = finalRests[i];
    if (!p || !fr) continue;
    p.arrivalAtParkingMs = fr.segment.startMs;
    p.restDurationSec = fr.segment.durationSec;
    p.departFromParkingMs = fr.segment.endMs;
  }
  for (let i = placed.length; i < finalRests.length; i++) {
    const r = finalRests[i];
    if (!r) continue;
    const target = positionAtDrivingTime(geometry, r.elapsedDrivingSec);
    placed.push(
      annotatedRest(
        r.kind,
        { lat: target.lat, lng: target.lng },
        "no_convergence",
        r.segment
      )
    );
  }
  return {
    rests: placed,
    finalGeometry: geometry,
    finalDrivingSeconds: drivingSeconds,
    finalArrivalMs: finalEta.arrivalMs,
    feasibility: assessRouteHosFeasibility(finalEta),
    reroutes
  };
}
function annotatedRest(kind, at, reason, segment) {
  return {
    kind,
    lat: at.lat,
    lng: at.lng,
    label: "",
    attributes: {},
    arrivalAtParkingMs: segment.startMs,
    restDurationSec: segment.durationSec,
    departFromParkingMs: segment.endMs,
    placement: "annotated",
    fallbackReason: reason
  };
}
async function findCandidates(findParking, at, kind, vehicleClass) {
  const weak = /* @__PURE__ */ new Map();
  for (const radiusM of SEARCH_RADII_M[kind]) {
    const found = await findParking({ at, kind, radiusM, vehicleClass });
    const good = [];
    for (const c of found) {
      if (parkingQuality(c.attributes, kind, vehicleClass) === "good") {
        good.push(c);
      } else {
        weak.set(c.id, c);
      }
    }
    if (good.length > 0) return { good, weak: [...weak.values()] };
  }
  return { good: [], weak: [...weak.values()] };
}
function pickBest(candidates, kind, target, vehicleClass) {
  let best = candidates[0];
  if (!best) throw new Error("pickBest requires at least one candidate");
  let bestScore = -Infinity;
  for (const c of candidates) {
    const detourM = 2 * haversineMeters(target, c);
    const score = scoreParking(c, kind, detourM, vehicleClass);
    if (score > bestScore) {
      bestScore = score;
      best = c;
    }
  }
  return best;
}
function nearestHints(weak, target) {
  return weak.map((c) => ({ c, d: haversineMeters(target, c) })).sort((a, b) => a.d - b.d).slice(0, MAX_NEARBY_HINTS).map(({ c }) => ({
    id: c.id,
    label: c.label,
    lat: c.lat,
    lng: c.lng,
    attributes: c.attributes
  }));
}
function orderedVia(userVia, insertedVia, geometry) {
  return [...userVia, ...insertedVia].map((point) => ({
    point,
    key: nearestCumulativeDistance(geometry, point)
  })).sort((a, b) => a.key - b.key).map((w) => w.point);
}

// src/utils/route-documents.ts
var EU_COUNTRY_CODES = /* @__PURE__ */ new Set([
  "AUT",
  "BEL",
  "BGR",
  "HRV",
  "CYP",
  "CZE",
  "DNK",
  "EST",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HUN",
  "IRL",
  "ITA",
  "LVA",
  "LTU",
  "LUX",
  "MLT",
  "NLD",
  "POL",
  "PRT",
  "ROU",
  "SVK",
  "SVN",
  "ESP",
  "SWE"
]);
function getRequiredDocuments(input) {
  const distinct = new Set(
    input.countryCodes.map((c) => c?.toUpperCase()).filter((c) => Boolean(c))
  );
  const codes = [...distinct];
  const hasNonEu = codes.some((c) => !EU_COUNTRY_CODES.has(c));
  const international = distinct.size > 1 || input.hasCustomsCrossing;
  const docs = [];
  if (international) docs.push("cmr");
  if (hasNonEu && distinct.size > 1 || input.hasCustomsCrossing)
    docs.push("customs");
  if (input.hazmatClasses && input.hazmatClasses.length > 0) docs.push("adr");
  return docs;
}
var CUSTOMS_CHECKPOINTS = /* @__PURE__ */ new Set([
  "border" /* Border */,
  "customs" /* Customs */
]);
function getRouteDocumentInput(route) {
  const countryCodes = route.countries?.length ? route.countries : (route.tollsBreakdown ?? []).map((t) => t.countryCode);
  return {
    countryCodes,
    // Origin counts too: a route departing a border/customs checkpoint needs the
    // border-document checklist even though the origin isn't part of `stops`.
    hasCustomsCrossing: CUSTOMS_CHECKPOINTS.has(route.startCheckpointType) || route.stops.some((s) => CUSTOMS_CHECKPOINTS.has(s.checkpointType)),
    hazmatClasses: route.shippedHazardousGoods
  };
}
function getRouteRequiredDocuments(route) {
  return getRequiredDocuments(getRouteDocumentInput(route));
}

// src/utils/route-tracking.ts
var DEG2RAD2 = Math.PI / 180;
var ROUTE_TRACKING = {
  /** Truck within this radius of a stop, at low speed, flips pending -> arrived. */
  GEOFENCE_RADIUS_M: 150,
  /** Leaving this radius (while moving) flips arrived -> completed. */
  DEPARTURE_RADIUS_M: 300,
  /** A driving fix at/under this speed (km/h) counts as "stopped at" a stop. */
  ARRIVAL_MAX_SPEED_KMH: 10,
  /** Speed (km/h) above which the truck counts as moving (departure / auto-start). */
  MOVING_MIN_SPEED_KMH: 5,
  /**
   * Final/destination stop completion: a truck parks at its last stop and never
   * leaves the departure radius, so the "left while moving" rule can't fire.
   * Once arrived at the LAST stop and dwelling this long, complete it (and the
   * route) so it doesn't hang in-progress forever.
   */
  FINAL_STOP_DWELL_SEC: 300,
  /** Telemetry older than this marks the snapshot stale (truck offline). */
  STALE_TELEMETRY_SEC: 600,
  /** Lateness beyond scheduled time + this grace flags the route delayed. */
  DELAY_GRACE_SEC: 900
};
function concatPolylinePoints(sections) {
  const out = [];
  for (const section of sections) {
    for (const p of section) out.push(p);
  }
  return out;
}
function polylineLengthM(points) {
  let total = 0;
  for (let i = 0; i < points.length - 1; i++) {
    total += haversineMeters(points[i], points[i + 1]);
  }
  return total;
}
function projectOnSegment(p, a, b) {
  const latRef = (a.lat + b.lat) / 2 * DEG2RAD2;
  const cos = Math.cos(latRef);
  const ax = a.lng * cos;
  const ay = a.lat;
  const bx = b.lng * cos;
  const by = b.lat;
  const px = p.lng * cos;
  const py = p.lat;
  const dx = bx - ax;
  const dy = by - ay;
  const len2 = dx * dx + dy * dy;
  let t = len2 === 0 ? 0 : ((px - ax) * dx + (py - ay) * dy) / len2;
  t = Math.max(0, Math.min(1, t));
  return {
    t,
    point: { lat: a.lat + (b.lat - a.lat) * t, lng: a.lng + (b.lng - a.lng) * t }
  };
}
function snapToPolyline(points, truck, fromIndex = 0) {
  if (points.length === 0) {
    return { index: 0, alongDistanceM: 0, offRouteM: Infinity };
  }
  if (points.length === 1) {
    return { index: 0, alongDistanceM: 0, offRouteM: haversineMeters(points[0], truck) };
  }
  const start = Math.max(0, Math.min(fromIndex, points.length - 2));
  let running = 0;
  for (let i = 0; i < start; i++) {
    running += haversineMeters(points[i], points[i + 1]);
  }
  let best = { index: start, alongDistanceM: running, offRouteM: Infinity };
  for (let i = start; i < points.length - 1; i++) {
    const a = points[i];
    const b = points[i + 1];
    const segLen = haversineMeters(a, b);
    const proj = projectOnSegment(truck, a, b);
    const off = haversineMeters(truck, proj.point);
    if (off < best.offRouteM) {
      best = { index: i, alongDistanceM: running + segLen * proj.t, offRouteM: off };
    }
    running += segLen;
  }
  return best;
}
function computeProgress(args) {
  const total = Math.max(0, args.totalDistanceM);
  const traveled = Math.max(0, Math.min(args.alongDistanceM, total));
  const remaining = Math.max(0, total - traveled);
  const progressPct = total > 0 ? traveled / total * 100 : 0;
  return {
    traveledM: Math.round(traveled),
    remainingM: Math.round(remaining),
    progressPct: Math.round(progressPct * 10) / 10
  };
}
function deriveRemainingDrivingSec(storedEstimatedDurationSec, remainingM, totalM) {
  if (!Number.isFinite(storedEstimatedDurationSec) || storedEstimatedDurationSec <= 0 || totalM <= 0) {
    return 0;
  }
  const ratio = Math.max(0, Math.min(1, remainingM / totalM));
  return Math.round(storedEstimatedDurationSec * ratio);
}
function detectGeofenceArrival(truck, stop, radiusM) {
  return haversineMeters(truck, stop) <= radiusM;
}
function classifyDelay(etaMs, scheduledMs, graceSec) {
  if (etaMs == null || scheduledMs == null) return { isDelayed: false, delaySec: 0 };
  const delaySec = Math.round((etaMs - scheduledMs) / 1e3);
  return { isDelayed: delaySec > graceSec, delaySec: Math.max(0, delaySec) };
}
function isTelemetryStale(lastTelemetryMs, nowMs, staleSec = ROUTE_TRACKING.STALE_TELEMETRY_SEC) {
  if (lastTelemetryMs == null) return true;
  return nowMs - lastTelemetryMs > staleSec * 1e3;
}

// src/utils/tacho-daily-summary.ts
var DEFAULT_NIGHT_WINDOW = { startHour: 23, endHour: 6 };
var NIGHT_WINDOW_BY_COUNTRY = {
  // Western Balkans — 22:00–06:00 labour codes; BA empirically matched to a
  // TachoSAFE reference printout.
  BA: { startHour: 22, endHour: 6 },
  RS: { startHour: 22, endHour: 6 },
  HR: { startHour: 22, endHour: 6 },
  ME: { startHour: 22, endHour: 6 },
  MK: { startHour: 22, endHour: 6 },
  SI: { startHour: 22, endHour: 6 },
  // Verified EU/UK national night periods.
  DE: { startHour: 23, endHour: 6 },
  // ArbZG §2(4): 23:00–06:00
  FR: { startHour: 21, endHour: 6 },
  // Code du travail L3122-2: 21:00–06:00
  AT: { startHour: 22, endHour: 5 },
  // AZG Nachtarbeit: 22:00–05:00
  GB: { startHour: 0, endHour: 4 },
  // RT(WT) Regs 2005 goods: 00:00–04:00
  UK: { startHour: 0, endHour: 4 },
  // alias for GB
  BG: { startHour: 22, endHour: 6 },
  // Labour Code (Кодекс на труда): 22:00–06:00
  RO: { startHour: 22, endHour: 6 },
  // Codul muncii Art 125: 22:00–06:00
  GR: { startHour: 22, endHour: 6 },
  // PD 88/1999: 22:00–06:00
  AL: { startHour: 22, endHour: 6 },
  // Labour Code: 22:00–06:00 (19–22 is a separate premium tier)
  TR: { startHour: 20, endHour: 6 }
  // Labour Law 4857 Art 69: night from 20:00 to 06:00
};
function resolveNightWindow(countryCode) {
  if (!countryCode) return DEFAULT_NIGHT_WINDOW;
  return NIGHT_WINDOW_BY_COUNTRY[countryCode.toUpperCase()] ?? DEFAULT_NIGHT_WINDOW;
}
function isNightHour(hour, w) {
  return w.startHour < w.endHour ? hour >= w.startHour && hour < w.endHour : hour >= w.startHour || hour < w.endHour;
}
var formatterCache = /* @__PURE__ */ new Map();
function getFormatter(timeZone) {
  let fmt = formatterCache.get(timeZone);
  if (!fmt) {
    fmt = new Intl.DateTimeFormat("en-US", {
      timeZone,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    formatterCache.set(timeZone, fmt);
  }
  return fmt;
}
function wallClock(epochMs, timeZone) {
  const parts = getFormatter(timeZone).formatToParts(epochMs);
  const get = (type) => Number(parts.find((p) => p.type === type)?.value ?? 0);
  return {
    year: get("year"),
    month: get("month"),
    day: get("day"),
    // hourCycle h23 still yields "24" for midnight in some ICU versions
    hour: get("hour") % 24,
    minute: get("minute"),
    second: get("second")
  };
}
function zonedEpoch(year, month, day, hour, timeZone) {
  const target = Date.UTC(year, month - 1, day, hour);
  let guess = target;
  for (let i = 0; i < 3; i++) {
    const w = wallClock(guess, timeZone);
    const asUtc = Date.UTC(w.year, w.month - 1, w.day, w.hour, w.minute, w.second);
    const diff = target - asUtc;
    if (diff === 0) break;
    guess += diff;
  }
  return guess;
}
function toDateKey(w) {
  const mm = String(w.month).padStart(2, "0");
  const dd = String(w.day).padStart(2, "0");
  return `${w.year}-${mm}-${dd}`;
}
function nextLocalDate(w) {
  const d = new Date(Date.UTC(w.year, w.month - 1, w.day));
  d.setUTCDate(d.getUTCDate() + 1);
  return [d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate()];
}
function boundariesBetween(startMs, endMs, timeZone, nightWindow) {
  const out = [];
  let w = wallClock(startMs, timeZone);
  let [y, m, d] = [w.year, w.month, w.day];
  const hours = [.../* @__PURE__ */ new Set([0, nightWindow.startHour, nightWindow.endHour])];
  for (; ; ) {
    for (const hour of hours) {
      const b = zonedEpoch(y, m, d, hour, timeZone);
      if (b > startMs && b < endMs) out.push(b);
    }
    const dayStart = zonedEpoch(y, m, d, 0, timeZone);
    if (dayStart >= endMs) break;
    [y, m, d] = nextLocalDate({ ...w, year: y, month: m, day: d });
  }
  return out.sort((a, b) => a - b);
}
var STATE_TO_TOTALS_KEY = {
  [0 /* Rest */]: "break",
  [1 /* Available */]: "available",
  [2 /* Work */]: "work",
  [3 /* Driving */]: "driving"
};
function emptyTotals() {
  return {
    break: { daySec: 0, nightSec: 0 },
    available: { daySec: 0, nightSec: 0 },
    work: { daySec: 0, nightSec: 0 },
    driving: { daySec: 0, nightSec: 0 }
  };
}
function buildVrnIntervals(cardEvents) {
  const sorted = [...cardEvents].sort(
    (a, b) => Date.parse(a.eventTime) - Date.parse(b.eventTime)
  );
  const intervals = [];
  const open = /* @__PURE__ */ new Map();
  for (const ev of sorted) {
    const t = Date.parse(ev.eventTime);
    if (Number.isNaN(t)) continue;
    const vrn = ev.vrn;
    if (!vrn) continue;
    if (ev.eventType === "inserted") {
      if (!open.has(vrn)) open.set(vrn, t);
    } else {
      const startMs = open.get(vrn);
      open.delete(vrn);
      intervals.push({ startMs: startMs ?? -Infinity, endMs: t, vrn });
    }
  }
  for (const [vrn, startMs] of open) {
    intervals.push({ startMs, endMs: Infinity, vrn });
  }
  return intervals;
}
function buildDailySummaries(activities, cardEvents, options) {
  const { timeZone, slot, fixedVrn } = options;
  const nightWindow = options.nightWindow ?? DEFAULT_NIGHT_WINDOW;
  const days = /* @__PURE__ */ new Map();
  const vrnIntervals = fixedVrn ? [] : buildVrnIntervals(cardEvents);
  const filtered = slot === void 0 ? activities : activities.filter((a) => a.slot === slot || a.slot === null);
  for (const record of filtered) {
    const startMs = Date.parse(record.startTime);
    const endMs = Date.parse(record.endTime);
    if (Number.isNaN(startMs) || Number.isNaN(endMs) || endMs <= startMs) {
      continue;
    }
    const cuts = boundariesBetween(startMs, endMs, timeZone, nightWindow);
    const edges = [startMs, ...cuts, endMs];
    for (let i = 0; i < edges.length - 1; i++) {
      const sliceStart = edges[i];
      const sliceEnd = edges[i + 1];
      const w = wallClock(sliceStart, timeZone);
      const dateKey = toDateKey(w);
      const isNight = isNightHour(w.hour, nightWindow);
      let day = days.get(dateKey);
      if (!day) {
        day = {
          dateKey,
          weekday: new Date(Date.UTC(w.year, w.month - 1, w.day)).getUTCDay(),
          vehicles: [],
          slices: [],
          totals: emptyTotals(),
          totalWork: { daySec: 0, nightSec: 0 }
        };
        days.set(dateKey, day);
      }
      day.slices.push({ state: record.state, startMs: sliceStart, endMs: sliceEnd, isNight });
      const seconds = Math.round((sliceEnd - sliceStart) / 1e3);
      const bucket = day.totals[STATE_TO_TOTALS_KEY[record.state]];
      if (isNight) bucket.nightSec += seconds;
      else bucket.daySec += seconds;
      if (record.state === 2 /* Work */ || record.state === 3 /* Driving */ || record.state === 1 /* Available */) {
        if (isNight) day.totalWork.nightSec += seconds;
        else day.totalWork.daySec += seconds;
      }
    }
  }
  const result = [...days.values()].sort(
    (a, b) => a.dateKey.localeCompare(b.dateKey)
  );
  for (const day of result) {
    if (fixedVrn) {
      day.vehicles = [fixedVrn];
      continue;
    }
    const dayStart = Math.min(...day.slices.map((s) => s.startMs));
    const dayEnd = Math.max(...day.slices.map((s) => s.endMs));
    const vrns = /* @__PURE__ */ new Set();
    for (const iv of vrnIntervals) {
      if (iv.startMs < dayEnd && iv.endMs > dayStart) vrns.add(iv.vrn);
    }
    day.vehicles = [...vrns];
  }
  return result;
}
function sumDailySummaries(days) {
  const totals = emptyTotals();
  const totalWork = { daySec: 0, nightSec: 0 };
  for (const day of days) {
    for (const key of Object.keys(totals)) {
      totals[key].daySec += day.totals[key].daySec;
      totals[key].nightSec += day.totals[key].nightSec;
    }
    totalWork.daySec += day.totalWork.daySec;
    totalWork.nightSec += day.totalWork.nightSec;
  }
  return { totals, totalWork };
}

// src/utils/tacho-segments.ts
var MIN2 = 60;
var HOUR2 = 3600;
var MERGE_GAP_MS = 60 * 1e3;
function normalizeSegments(activities, slot) {
  const source = (slot === void 0 ? activities : activities.filter((a) => a.slot === slot || a.slot === null)).map((a) => ({
    state: a.state,
    startMs: Date.parse(a.startTime),
    endMs: Date.parse(a.endTime)
  })).filter(
    (s) => !Number.isNaN(s.startMs) && !Number.isNaN(s.endMs) && s.endMs > s.startMs
  ).sort((a, b) => a.startMs - b.startMs);
  const merged = [];
  for (const seg of source) {
    const prev = merged[merged.length - 1];
    if (prev && seg.startMs - prev.endMs > MERGE_GAP_MS) {
      if (prev.state === 0 /* Rest */) {
        prev.endMs = seg.startMs;
      } else {
        merged.push({
          state: 0 /* Rest */,
          startMs: prev.endMs,
          endMs: seg.startMs
        });
      }
    }
    const last = merged[merged.length - 1];
    if (last && last.state === seg.state && seg.startMs - last.endMs <= MERGE_GAP_MS) {
      last.endMs = Math.max(last.endMs, seg.endMs);
    } else {
      merged.push({ ...seg });
    }
  }
  return merged;
}
var sec = (ms) => Math.round(ms / 1e3);
function qualifyingRests(segments, minSec) {
  return segments.filter(
    (s) => s.state === 0 /* Rest */ && sec(s.endMs - s.startMs) >= minSec
  ).map((s) => ({
    startMs: s.startMs,
    endMs: s.endMs,
    durationSec: sec(s.endMs - s.startMs)
  }));
}
function detectShifts(segments) {
  if (segments.length === 0) return [];
  const dailyRests = qualifyingRests(segments, HOS_ETA.REDUCED_DAILY_REST_SEC);
  const boundaries = [
    segments[0].startMs,
    ...dailyRests.map((r) => r.endMs),
    segments[segments.length - 1].endMs
  ];
  const shifts = [];
  for (let i = 0; i < boundaries.length - 1; i++) {
    const startMs = boundaries[i];
    const terminatingRest = dailyRests.find((r) => r.endMs > startMs && r.startMs >= startMs) ?? null;
    const endMs = terminatingRest ? terminatingRest.startMs : boundaries[boundaries.length - 1];
    if (endMs <= startMs) continue;
    let drivingSec = 0;
    let activeSec = 0;
    let longestRestInWindowSec = 0;
    const windowEnd = startMs + 24 * HOUR2 * 1e3;
    for (const s of segments) {
      if (s.state !== 0 /* Rest */) {
        const oStart = Math.max(s.startMs, startMs);
        const oEnd = Math.min(s.endMs, endMs);
        if (oEnd > oStart) {
          activeSec += sec(oEnd - oStart);
          if (s.state === 3 /* Driving */) {
            drivingSec += sec(oEnd - oStart);
          }
        }
      }
      if (s.state === 0 /* Rest */) {
        if (s.startMs < windowEnd && s.endMs > startMs) {
          longestRestInWindowSec = Math.max(
            longestRestInWindowSec,
            sec(s.endMs - s.startMs)
          );
        }
      }
    }
    shifts.push({
      startMs,
      endMs,
      drivingSec,
      activeSec,
      longestRestInWindowSec,
      terminatingRest
    });
    if (!terminatingRest) break;
  }
  return shifts;
}
function weekStartMs(epochMs, timeZone) {
  const w = wallClock(epochMs, timeZone);
  const dayStart = zonedEpoch(w.year, w.month, w.day, 0, timeZone);
  const weekday = new Date(Date.UTC(w.year, w.month - 1, w.day)).getUTCDay();
  const daysSinceMonday = (weekday + 6) % 7;
  if (daysSinceMonday === 0) return dayStart;
  const d = new Date(Date.UTC(w.year, w.month - 1, w.day));
  d.setUTCDate(d.getUTCDate() - daysSinceMonday);
  return zonedEpoch(
    d.getUTCFullYear(),
    d.getUTCMonth() + 1,
    d.getUTCDate(),
    0,
    timeZone
  );
}
function nextWeekStartMs(weekStart, timeZone) {
  const w = wallClock(weekStart, timeZone);
  const d = new Date(Date.UTC(w.year, w.month - 1, w.day));
  d.setUTCDate(d.getUTCDate() + 7);
  return zonedEpoch(
    d.getUTCFullYear(),
    d.getUTCMonth() + 1,
    d.getUTCDate(),
    0,
    timeZone
  );
}
function detectWeeks(segments, timeZone) {
  if (segments.length === 0) return [];
  const firstMs = segments[0].startMs;
  const lastMs = segments[segments.length - 1].endMs;
  const weeks = [];
  let ws = weekStartMs(firstMs, timeZone);
  while (ws < lastMs) {
    const we = nextWeekStartMs(ws, timeZone);
    let drivingSec = 0;
    for (const s of segments) {
      if (s.state !== 3 /* Driving */) continue;
      const oStart = Math.max(s.startMs, ws);
      const oEnd = Math.min(s.endMs, we);
      if (oEnd > oStart) drivingSec += sec(oEnd - oStart);
    }
    weeks.push({ startMs: ws, endMs: we, drivingSec });
    ws = we;
  }
  return weeks;
}
function detectContinuousBlocks(segments) {
  const blocks = [];
  let acc = 0;
  let blockStart = null;
  let splitFirstPartSeen = false;
  const close = (endMs) => {
    if (blockStart !== null && acc > 0) {
      blocks.push({ startMs: blockStart, endMs, drivingSec: acc });
    }
    acc = 0;
    blockStart = null;
  };
  for (const s of segments) {
    const dur = sec(s.endMs - s.startMs);
    if (s.state === 3 /* Driving */) {
      if (blockStart === null) blockStart = s.startMs;
      acc += dur;
    } else if (s.state === 0 /* Rest */) {
      if (dur >= HOS_ETA.BREAK_SEC || dur >= HOS_ETA.REDUCED_DAILY_REST_SEC) {
        close(s.startMs);
        splitFirstPartSeen = false;
      } else if (splitFirstPartSeen && dur >= 30 * MIN2) {
        close(s.startMs);
        splitFirstPartSeen = false;
      } else if (dur >= 15 * MIN2) {
        splitFirstPartSeen = true;
      }
    }
  }
  close(segments.length ? segments[segments.length - 1].endMs : 0);
  return blocks;
}

// src/utils/tacho-infringement-rules.ts
function bandFor(value, bands) {
  for (const b of bands) {
    if (value >= b.minSec) return b.severity;
  }
  return "MI";
}
var iso = (ms) => new Date(ms).toISOString();
function continuousDrivingRule({
  blocks,
  covered
}) {
  const out = [];
  for (const block of blocks) {
    if (!covered(block.startMs, block.endMs)) continue;
    if (block.drivingSec <= HOS_ETA.CONTINUOUS_CAP_SEC) continue;
    const severity = bandFor(block.drivingSec, [
      { severity: "VSI", minSec: 6 * HOUR2 },
      { severity: "SI", minSec: 5 * HOUR2 },
      { severity: "MI", minSec: 0 }
    ]);
    out.push({
      ruleId: "CONTINUOUS_DRIVING_EXCEEDED",
      article: "EU 561-7",
      severity,
      periodStart: iso(block.startMs),
      periodEnd: iso(block.endMs),
      measured: block.drivingSec,
      limit: HOS_ETA.CONTINUOUS_CAP_SEC,
      unit: "seconds"
    });
  }
  return out;
}
function dailyDrivingRule({
  shifts,
  blocks,
  covered,
  options: { timeZone }
}) {
  const out = [];
  const extensionsUsedPerWeek = /* @__PURE__ */ new Map();
  for (const shift of shifts) {
    if (shift.drivingSec <= HOS_ETA.DAILY_DRIVING_CAP_SEC) continue;
    const ws = weekStartMs(shift.startMs, timeZone);
    const used = extensionsUsedPerWeek.get(ws) ?? 0;
    const extended = used < HOS_ETA.DAILY_DRIVING_EXTENSIONS_PER_WEEK;
    if (extended) extensionsUsedPerWeek.set(ws, used + 1);
    if (extended && shift.drivingSec <= HOS_ETA.DAILY_DRIVING_EXTENDED_SEC) {
      continue;
    }
    if (!covered(shift.startMs, shift.endMs)) continue;
    const tookBreak = blocks.filter(
      (b) => b.startMs >= shift.startMs && b.startMs < shift.endMs
    ).length > 1;
    const bands = extended ? [
      { severity: "MSI", minSec: 15 * HOUR2 },
      { severity: "VSI", minSec: 12 * HOUR2 },
      { severity: "SI", minSec: 11 * HOUR2 },
      { severity: "MI", minSec: 0 }
    ] : [
      { severity: "MSI", minSec: 13.5 * HOUR2 },
      { severity: "VSI", minSec: 11 * HOUR2 },
      { severity: "SI", minSec: 10 * HOUR2 },
      { severity: "MI", minSec: 0 }
    ];
    const graded = bandFor(shift.drivingSec, bands);
    out.push({
      ruleId: "DAILY_DRIVING_EXCEEDED",
      article: "EU 561-6",
      severity: graded === "MSI" && tookBreak ? "VSI" : graded,
      periodStart: iso(shift.startMs),
      periodEnd: iso(shift.endMs),
      measured: shift.drivingSec,
      limit: extended ? HOS_ETA.DAILY_DRIVING_EXTENDED_SEC : HOS_ETA.DAILY_DRIVING_CAP_SEC,
      unit: "seconds"
    });
  }
  return out;
}
function weeklyDrivingRule({
  weeks,
  coveredOverlap
}) {
  const out = [];
  for (const week of weeks) {
    if (!coveredOverlap(week.startMs, week.endMs)) continue;
    if (week.drivingSec <= HOS_ETA.WEEKLY_DRIVING_CAP_SEC) continue;
    const severity = bandFor(week.drivingSec, [
      { severity: "MSI", minSec: 70 * HOUR2 },
      { severity: "VSI", minSec: 65 * HOUR2 },
      { severity: "SI", minSec: 60 * HOUR2 },
      { severity: "MI", minSec: 0 }
    ]);
    out.push({
      ruleId: "WEEKLY_DRIVING_EXCEEDED",
      article: "EU 561-6",
      severity,
      periodStart: iso(week.startMs),
      periodEnd: iso(week.endMs),
      measured: week.drivingSec,
      limit: HOS_ETA.WEEKLY_DRIVING_CAP_SEC,
      unit: "seconds"
    });
  }
  return out;
}
var FORTNIGHT_CAP_SEC = 90 * HOUR2;
function fortnightDrivingRule({
  weeks,
  coveredOverlap
}) {
  const out = [];
  for (let i = 0; i < weeks.length - 1; i++) {
    const a = weeks[i];
    const b = weeks[i + 1];
    if (!coveredOverlap(a.startMs, b.endMs)) continue;
    const total = a.drivingSec + b.drivingSec;
    if (total <= FORTNIGHT_CAP_SEC) continue;
    const severity = bandFor(total, [
      { severity: "MSI", minSec: 112.5 * HOUR2 },
      { severity: "VSI", minSec: 105 * HOUR2 },
      { severity: "SI", minSec: 100 * HOUR2 },
      { severity: "MI", minSec: 0 }
    ]);
    out.push({
      ruleId: "FORTNIGHT_DRIVING_EXCEEDED",
      article: "EU 561-6",
      severity,
      periodStart: iso(a.startMs),
      periodEnd: iso(b.endMs),
      measured: total,
      limit: FORTNIGHT_CAP_SEC,
      unit: "seconds"
    });
  }
  return out;
}
function dailyRestRule({ shifts, covered }) {
  const out = [];
  for (const shift of shifts) {
    if (!shift.terminatingRest) continue;
    if (!covered(shift.startMs, shift.terminatingRest.endMs)) continue;
    const rest = shift.longestRestInWindowSec;
    if (rest >= HOS_ETA.REDUCED_DAILY_REST_SEC) continue;
    const severity = bandFor(HOS_ETA.DAILY_REST_SEC - rest, [
      { severity: "VSI", minSec: 2.5 * HOUR2 },
      // rest < 8.5h
      { severity: "SI", minSec: 1 * HOUR2 },
      // rest < 10h
      { severity: "MI", minSec: 0 }
    ]);
    out.push({
      ruleId: "DAILY_REST_INSUFFICIENT",
      article: "EU 561-8",
      severity,
      periodStart: iso(shift.startMs),
      periodEnd: iso(shift.terminatingRest.endMs),
      measured: rest,
      limit: HOS_ETA.DAILY_REST_SEC,
      unit: "seconds"
    });
  }
  return out;
}
function reducedDailyRestCountRule({
  shifts,
  weeklyRests,
  covered
}) {
  const out = [];
  for (let i = 0; i < weeklyRests.length - 1; i++) {
    const from = weeklyRests[i].endMs;
    const to = weeklyRests[i + 1].startMs;
    if (!covered(from, to)) continue;
    const reducedCount = shifts.filter(
      (s) => s.terminatingRest && s.terminatingRest.startMs >= from && s.terminatingRest.endMs <= to && s.terminatingRest.durationSec >= HOS_ETA.REDUCED_DAILY_REST_SEC && s.terminatingRest.durationSec < HOS_ETA.DAILY_REST_SEC
    ).length;
    if (reducedCount <= 3) continue;
    out.push({
      ruleId: "REDUCED_DAILY_REST_COUNT_EXCEEDED",
      article: "EU 561-8",
      severity: "SI",
      periodStart: iso(from),
      periodEnd: iso(to),
      measured: reducedCount,
      limit: 3,
      unit: "count"
    });
  }
  return out;
}
var weeklyRestSeverity = (longestSec) => bandFor(HOS_ETA.REDUCED_WEEKLY_REST_SEC - longestSec, [
  { severity: "VSI", minSec: 4 * HOUR2 },
  // <20h
  { severity: "SI", minSec: 2 * HOUR2 },
  // <22h
  { severity: "MI", minSec: 0 }
]);
function weeklyRestRule({
  segments,
  weeklyRests,
  coverStart,
  covered
}) {
  const out = [];
  {
    const openWindowEnd = coverStart + HOS_ETA.WEEKLY_REST_DUE_AFTER_SEC * 1e3;
    const firstRest = weeklyRests[0];
    if (covered(coverStart, openWindowEnd) && (!firstRest || firstRest.startMs > openWindowEnd)) {
      const attempts = qualifyingRests(segments, 0).filter(
        (r) => r.startMs >= coverStart && r.startMs <= openWindowEnd
      );
      const longest = attempts.reduce((m, r) => Math.max(m, r.durationSec), 0);
      out.push({
        ruleId: "WEEKLY_REST_INSUFFICIENT",
        article: "EU 561-8",
        severity: weeklyRestSeverity(longest),
        periodStart: iso(coverStart),
        periodEnd: iso(openWindowEnd),
        measured: longest,
        limit: HOS_ETA.REDUCED_WEEKLY_REST_SEC,
        unit: "seconds"
      });
    }
  }
  for (let i = 0; i < weeklyRests.length; i++) {
    const prev = weeklyRests[i];
    const windowEnd = prev.endMs + HOS_ETA.WEEKLY_REST_DUE_AFTER_SEC * 1e3;
    if (!covered(prev.endMs, windowEnd)) continue;
    const next = weeklyRests[i + 1];
    if (next && next.startMs <= windowEnd) continue;
    const attempts = qualifyingRests(segments, 0).filter(
      (r) => r.startMs > prev.endMs && r.startMs <= windowEnd
    );
    const longest = attempts.reduce((m, r) => Math.max(m, r.durationSec), 0);
    out.push({
      ruleId: "WEEKLY_REST_INSUFFICIENT",
      article: "EU 561-8",
      severity: weeklyRestSeverity(longest),
      periodStart: iso(prev.endMs),
      periodEnd: iso(windowEnd),
      measured: longest,
      limit: HOS_ETA.REDUCED_WEEKLY_REST_SEC,
      unit: "seconds"
    });
  }
  return out;
}
function twoWeeklyRestsRule({
  weeks,
  weeklyRests,
  covered
}) {
  const out = [];
  for (let i = 0; i < weeks.length - 1; i++) {
    const from = weeks[i].startMs;
    const to = weeks[i + 1].endMs;
    if (!covered(from, to)) continue;
    const inWindow = weeklyRests.filter(
      (r) => r.endMs > from && r.startMs < to
    );
    const regular = inWindow.some(
      (r) => r.durationSec >= HOS_ETA.WEEKLY_REST_SEC
    );
    if (inWindow.length >= 2 && regular) continue;
    out.push({
      ruleId: "TWO_WEEKLY_RESTS_INCORRECT",
      article: "EU 561-8",
      severity: "SI",
      periodStart: iso(from),
      periodEnd: iso(to),
      measured: inWindow.length,
      limit: 2,
      unit: "count"
    });
  }
  return out;
}
var CARD_WITHDRAWAL_MIN_SEC = 15 * MIN2;
var MARKING_MIN_ACTIVE_SEC = 15 * MIN2;
var MARK_TOLERANCE_MS = HOUR2 * 1e3;
function cardWithdrawalRule({
  activities,
  options: { slot },
  segments,
  covered
}) {
  const out = [];
  for (const gap of unknownCardOutIntervals(activities, slot)) {
    if (sec(gap.endMs - gap.startMs) < CARD_WITHDRAWAL_MIN_SEC) continue;
    if (!covered(gap.startMs, gap.endMs)) continue;
    const mid = (gap.startMs + gap.endMs) / 2;
    const idx = segments.findIndex((x) => x.startMs <= mid && mid < x.endMs);
    if (idx <= 0 || idx >= segments.length - 1) continue;
    const host = segments[idx];
    if (host.state === 0 /* Rest */ && sec(host.endMs - host.startMs) >= HOS_ETA.REDUCED_DAILY_REST_SEC) {
      continue;
    }
    out.push({
      ruleId: "CARD_WITHDRAWAL",
      article: "EU 165-34",
      severity: "VSI",
      periodStart: iso(gap.startMs),
      periodEnd: iso(gap.endMs),
      measured: sec(gap.endMs - gap.startMs),
      limit: 0,
      unit: "seconds"
    });
  }
  return out;
}
function workPeriodMarkingRule({
  options,
  shifts,
  covered
}) {
  const out = [];
  const marks = placeMarks(options.places);
  if (marks) {
    for (const shift of shifts) {
      if (shift.activeSec < MARKING_MIN_ACTIVE_SEC) continue;
      if (shift.startMs < marks.coverFromMs) continue;
      const endMs = shift.terminatingRest?.endMs ?? shift.endMs;
      if (!covered(shift.startMs, endMs)) continue;
      const hasBegin = marks.begins.some(
        (t) => t >= shift.startMs - MARK_TOLERANCE_MS && t <= shift.endMs
      );
      const hasEnd = !shift.terminatingRest || marks.ends.some(
        (t) => t >= shift.startMs && t <= endMs + MARK_TOLERANCE_MS
      );
      const missing = (hasBegin ? 0 : 1) + (hasEnd ? 0 : 1);
      if (missing === 0) continue;
      out.push({
        ruleId: "WORK_PERIOD_MARKING_MISSING",
        article: "EU 165-34",
        severity: "SI",
        periodStart: iso(shift.startMs),
        periodEnd: iso(shift.endMs),
        measured: missing,
        limit: 0,
        unit: "count"
      });
    }
  }
  return out;
}
function unknownCardOutIntervals(activities, slot) {
  const raw = activities.filter(
    (a) => a.cardWithdrawn === "unknown" && (slot === void 0 || a.slot === slot || a.slot === null)
  ).map((a) => ({
    startMs: Date.parse(a.startTime),
    endMs: Date.parse(a.endTime)
  })).filter((g) => g.endMs > g.startMs).sort((a, b) => a.startMs - b.startMs);
  const merged = [];
  for (const g of raw) {
    const last = merged[merged.length - 1];
    if (last && g.startMs - last.endMs <= MERGE_GAP_MS) {
      last.endMs = Math.max(last.endMs, g.endMs);
    } else {
      merged.push({ ...g });
    }
  }
  return merged;
}
function placeMarks(places) {
  if (!places?.length) return null;
  const begins = [];
  const ends = [];
  let coverFromMs = Number.POSITIVE_INFINITY;
  for (const p of places) {
    const t = Date.parse(p.time);
    if (Number.isNaN(t)) continue;
    coverFromMs = Math.min(coverFromMs, t);
    const type = (p.entryType ?? "").toUpperCase();
    if (type.startsWith("BEGIN")) begins.push(t);
    else if (type.startsWith("END")) ends.push(t);
  }
  if (!Number.isFinite(coverFromMs)) return null;
  return { begins, ends, coverFromMs };
}
var INFRINGEMENT_RULES = [
  continuousDrivingRule,
  dailyDrivingRule,
  weeklyDrivingRule,
  fortnightDrivingRule,
  dailyRestRule,
  reducedDailyRestCountRule,
  weeklyRestRule,
  twoWeeklyRestsRule,
  cardWithdrawalRule,
  workPeriodMarkingRule
];

// src/utils/tacho-infringement-types.ts
var TACHO_INFRINGEMENT_RULES = [
  { ruleId: "DAILY_DRIVING_EXCEEDED", article: "EU 561-6" },
  { ruleId: "WEEKLY_DRIVING_EXCEEDED", article: "EU 561-6" },
  { ruleId: "FORTNIGHT_DRIVING_EXCEEDED", article: "EU 561-6" },
  { ruleId: "CONTINUOUS_DRIVING_EXCEEDED", article: "EU 561-7" },
  { ruleId: "DAILY_REST_INSUFFICIENT", article: "EU 561-8" },
  { ruleId: "REDUCED_DAILY_REST_COUNT_EXCEEDED", article: "EU 561-8" },
  { ruleId: "WEEKLY_REST_INSUFFICIENT", article: "EU 561-8" },
  { ruleId: "TWO_WEEKLY_RESTS_INCORRECT", article: "EU 561-8" },
  { ruleId: "CARD_WITHDRAWAL", article: "EU 165-34" },
  { ruleId: "WORK_PERIOD_MARKING_MISSING", article: "EU 165-34" }
];

// src/utils/tacho-day-usage.ts
function dayLimitUsage(activities, options) {
  const { timeZone, slot, dayStartMs, dayEndMs } = options;
  const segments = normalizeSegments(activities, slot);
  const drivingBetween = (from, to) => segments.reduce((sum, s) => {
    if (s.state !== 3 /* Driving */) return sum;
    const o = Math.min(s.endMs, to) - Math.max(s.startMs, from);
    return o > 0 ? sum + sec(o) : sum;
  }, 0);
  const continuousDrivingSec = detectContinuousBlocks(segments).filter((b) => b.startMs < dayEndMs && b.endMs > dayStartMs).reduce((max, b) => Math.max(max, b.drivingSec), 0);
  return {
    dailyDrivingSec: drivingBetween(dayStartMs, dayEndMs),
    dailyLimitSec: HOS_ETA.DAILY_DRIVING_CAP_SEC,
    continuousDrivingSec,
    continuousLimitSec: HOS_ETA.CONTINUOUS_CAP_SEC,
    weeklyDrivingSec: drivingBetween(
      weekStartMs(dayStartMs, timeZone),
      dayEndMs
    ),
    weeklyLimitSec: HOS_ETA.WEEKLY_DRIVING_CAP_SEC
  };
}

// src/utils/tacho-infringements.ts
function detectInfringements(activities, options) {
  const { timeZone, slot, periodFrom, periodTo } = options;
  const segments = normalizeSegments(activities, slot);
  if (segments.length === 0) return [];
  const coverStart = periodFrom ? Date.parse(periodFrom) : segments[0].startMs;
  const coverEnd = periodTo ? Date.parse(periodTo) : segments[segments.length - 1].endMs;
  const covered = (startMs, endMs) => startMs >= coverStart && endMs <= coverEnd;
  const coveredOverlap = (startMs, endMs) => startMs < coverEnd && endMs > coverStart;
  const ctx = {
    activities,
    options,
    segments,
    shifts: detectShifts(segments),
    blocks: detectContinuousBlocks(segments),
    weeks: detectWeeks(segments, timeZone),
    weeklyRests: qualifyingRests(segments, HOS_ETA.REDUCED_WEEKLY_REST_SEC),
    coverStart,
    covered,
    coveredOverlap
  };
  return INFRINGEMENT_RULES.flatMap((rule) => rule(ctx)).sort(
    (a, b) => Date.parse(a.periodStart) - Date.parse(b.periodStart)
  );
}

// src/utils/tacho-nation.ts
var NATION_ALPHA = {
  AUSTRIA: "A",
  ALBANIA: "AL",
  ANDORRA: "AND",
  ARMENIA: "ARM",
  AZERBAIJAN: "AZ",
  BELGIUM: "B",
  BULGARIA: "BG",
  BOSNIA_HERZEGOVINA: "BIH",
  BELARUS: "BY",
  SWITZERLAND: "CH",
  CYPRUS: "CY",
  CZECH_REPUBLIC: "CZ",
  GERMANY: "D",
  DENMARK: "DK",
  SPAIN: "E",
  ESTONIA: "EST",
  FRANCE: "F",
  FINLAND: "FIN",
  LIECHTENSTEIN: "FL",
  FAROE_ISLANDS: "FO",
  UNITED_KINGDOM: "UK",
  GEORGIA: "GE",
  GREECE: "GR",
  HUNGARY: "H",
  CROATIA: "HR",
  ITALY: "I",
  IRELAND: "IRL",
  ICELAND: "IS",
  KAZAKHSTAN: "KZ",
  LUXEMBOURG: "L",
  LITHUANIA: "LT",
  LATVIA: "LV",
  MALTA: "M",
  MONACO: "MC",
  MOLDOVA: "MD",
  NORTH_MACEDONIA: "MK",
  N_MACEDONIA: "MK",
  MACEDONIA: "MK",
  NORWAY: "N",
  NETHERLANDS: "NL",
  PORTUGAL: "P",
  POLAND: "PL",
  ROMANIA: "RO",
  SAN_MARINO: "RSM",
  RUSSIA: "RUS",
  SWEDEN: "S",
  SLOVAKIA: "SK",
  SLOVENIA: "SLO",
  TURKMENISTAN: "TM",
  TURKEY: "TR",
  UKRAINE: "UA",
  VATICAN_CITY: "V",
  SERBIA: "SRB",
  MONTENEGRO: "MNE",
  KYRGYZ_REPUBLIC: "KG",
  EUROPEAN_COMMUNITY: "EC",
  REST_OF_WORLD: "WLD"
};
var UNKNOWN_NATION = /* @__PURE__ */ new Set([
  "NATION_NUMERIC_UNSPECIFIED",
  "NATION_NUMERIC_UNRECOGNIZED",
  "NATION_NUMERIC_DEFAULT",
  "NATION_NUMERIC_EMPTY",
  "NO_INFORMATION_AVAILABLE",
  "UNKNOWN",
  "RESERVED"
]);
function isUnknownNation(nation) {
  return !nation || UNKNOWN_NATION.has(nation.toUpperCase());
}
function nationShortCode(nation) {
  if (isUnknownNation(nation)) return null;
  return NATION_ALPHA[nation.toUpperCase()] ?? null;
}
var NATION_ISO2 = {
  AUSTRIA: "AT",
  ALBANIA: "AL",
  ANDORRA: "AD",
  ARMENIA: "AM",
  AZERBAIJAN: "AZ",
  BELGIUM: "BE",
  BULGARIA: "BG",
  BOSNIA_HERZEGOVINA: "BA",
  BELARUS: "BY",
  SWITZERLAND: "CH",
  CYPRUS: "CY",
  CZECH_REPUBLIC: "CZ",
  GERMANY: "DE",
  DENMARK: "DK",
  SPAIN: "ES",
  ESTONIA: "EE",
  FRANCE: "FR",
  FINLAND: "FI",
  LIECHTENSTEIN: "LI",
  FAROE_ISLANDS: "FO",
  UNITED_KINGDOM: "GB",
  GEORGIA: "GE",
  GREECE: "GR",
  HUNGARY: "HU",
  CROATIA: "HR",
  ITALY: "IT",
  IRELAND: "IE",
  ICELAND: "IS",
  KAZAKHSTAN: "KZ",
  LUXEMBOURG: "LU",
  LITHUANIA: "LT",
  LATVIA: "LV",
  MALTA: "MT",
  MONACO: "MC",
  MOLDOVA: "MD",
  NORTH_MACEDONIA: "MK",
  N_MACEDONIA: "MK",
  MACEDONIA: "MK",
  NORWAY: "NO",
  NETHERLANDS: "NL",
  PORTUGAL: "PT",
  POLAND: "PL",
  ROMANIA: "RO",
  SAN_MARINO: "SM",
  RUSSIA: "RU",
  SWEDEN: "SE",
  SLOVAKIA: "SK",
  SLOVENIA: "SI",
  TURKMENISTAN: "TM",
  TURKEY: "TR",
  UKRAINE: "UA",
  VATICAN_CITY: "VA",
  SERBIA: "RS",
  MONTENEGRO: "ME",
  KYRGYZ_REPUBLIC: "KG"
};
function nationIso2(nation) {
  if (isUnknownNation(nation)) return null;
  return NATION_ISO2[nation.toUpperCase()] ?? null;
}
var NATION_ENUM_ORDER = [
  "NATION_NUMERIC_UNSPECIFIED",
  "NATION_NUMERIC_UNRECOGNIZED",
  "NATION_NUMERIC_DEFAULT",
  "NATION_NUMERIC_EMPTY",
  "AUSTRIA",
  "ALBANIA",
  "ANDORRA",
  "ARMENIA",
  "AZERBAIJAN",
  "BELGIUM",
  "BULGARIA",
  "BOSNIA_HERZEGOVINA",
  "BELARUS",
  "SWITZERLAND",
  "CYPRUS",
  "CZECH_REPUBLIC",
  "GERMANY",
  "DENMARK",
  "SPAIN",
  "ESTONIA",
  "FRANCE",
  "FINLAND",
  "LIECHTENSTEIN",
  "FAROE_ISLANDS",
  "UNITED_KINGDOM",
  "GEORGIA",
  "GREECE",
  "HUNGARY",
  "CROATIA",
  "ITALY",
  "IRELAND",
  "ICELAND",
  "KAZAKHSTAN",
  "LUXEMBOURG",
  "LITHUANIA",
  "LATVIA",
  "MALTA",
  "MONACO",
  "MOLDOVA",
  "NORTH_MACEDONIA",
  "NORWAY",
  "NETHERLANDS",
  "PORTUGAL",
  "POLAND",
  "ROMANIA",
  "SAN_MARINO",
  "RUSSIA",
  "SWEDEN",
  "SLOVAKIA",
  "SLOVENIA",
  "TURKMENISTAN",
  "TURKEY",
  "UKRAINE",
  "VATICAN_CITY",
  "SERBIA",
  "MONTENEGRO",
  "KYRGYZ_REPUBLIC",
  "EUROPEAN_COMMUNITY",
  "REST_OF_WORLD"
];
function fixFullCardNation(nation) {
  if (!nation) return null;
  const idx = NATION_ENUM_ORDER.indexOf(nation.toUpperCase());
  if (idx <= 0) return null;
  return NATION_ENUM_ORDER[idx + 3] ?? null;
}

// src/utils/tacho-event-type.ts
var EVENT_FAULT_CODES = {
  GENERAL_NO_FURTHER_DETAILS: 0,
  GENERAL_INSERTION_OF_NON_VALID_CARD: 1,
  GENERAL_CARD_CONFLICT: 2,
  GENERAL_TIME_OVERLAP: 3,
  GENERAL_DRIVING_WITHOUT_APPROPRIATE_CARD: 4,
  GENERAL_CARD_INSERTION_WHILE_DRIVING: 5,
  GENERAL_LAST_CARD_SESSION_NOT_CORRECTLY_CLOSED: 6,
  GENERAL_OVER_SPEEDING: 7,
  GENERAL_POWER_SUPPLY_INTERRUPTION: 8,
  GENERAL_MOTION_DATA_ERROR: 9,
  GENERAL_VEHICLE_MOTION_CONFLICT: 10,
  GENERAL_TIME_CONFLICT_GNSS_VS_VU: 11,
  GENERAL_COMM_ERROR_REMOTE_COMM_FACILITY: 12,
  GENERAL_ABSENCE_OF_POSITION_INFO_FROM_GNSS: 13,
  GENERAL_COMM_ERROR_EXTERNAL_GNSS_FACILITY: 14,
  GENERAL_GNSS_ANOMALY: 15,
  VU_SEC_NO_FURTHER_DETAILS: 16,
  VU_SEC_MOTION_SENSOR_AUTH_FAILURE: 17,
  VU_SEC_TACHOGRAPH_CARD_AUTH_FAILURE: 18,
  VU_SEC_UNAUTHORISED_CHANGE_OF_MOTION_SENSOR: 19,
  VU_SEC_CARD_DATA_INPUT_INTEGRITY_ERROR: 20,
  VU_SEC_STORED_USER_DATA_INTEGRITY_ERROR: 21,
  VU_SEC_INTERNAL_DATA_TRANSFER_ERROR: 22,
  VU_SEC_UNAUTHORISED_CASE_OPENING: 23,
  VU_SEC_HARDWARE_SABOTAGE: 24,
  VU_SEC_TAMPER_DETECTION_OF_GNSS: 25,
  VU_SEC_EXTERNAL_GNSS_FACILITY_AUTH_FAILURE: 26,
  VU_SEC_EXTERNAL_GNSS_FACILITY_CERT_EXPIRED: 27,
  VU_SEC_INCONSISTENCY_MOTION_VS_ACTIVITY: 28,
  SENSOR_SEC_NO_FURTHER_DETAILS: 32,
  SENSOR_SEC_AUTHENTICATION_FAILURE: 33,
  SENSOR_SEC_STORED_DATA_INTEGRITY_ERROR: 34,
  SENSOR_SEC_INTERNAL_DATA_TRANSFER_ERROR: 35,
  SENSOR_SEC_UNAUTHORISED_CASE_OPENING: 36,
  SENSOR_SEC_HARDWARE_SABOTAGE: 37,
  FAULT_REC_EQ_NO_FURTHER_DETAILS: 48,
  FAULT_REC_EQ_VU_INTERNAL_FAULT: 49,
  FAULT_REC_EQ_PRINTER_FAULT: 50,
  FAULT_REC_EQ_DISPLAY_FAULT: 51,
  FAULT_REC_EQ_DOWNLOADING_FAULT: 52,
  FAULT_REC_EQ_SENSOR_FAULT: 53,
  FAULT_REC_EQ_INTERNAL_GNSS_RECEIVER: 54,
  FAULT_REC_EQ_EXTERNAL_GNSS_FACILITY: 55,
  FAULT_REC_EQ_REMOTE_COMM_FACILITY: 56,
  FAULT_REC_EQ_ITS_INTERFACE: 57,
  FAULT_REC_EQ_INTERNAL_SENSOR_FAULT: 58,
  FAULT_CARD_NO_FURTHER_DETAILS: 64
};
function isKnownEventFaultType(type) {
  return Object.hasOwn(EVENT_FAULT_CODES, type);
}
function eventFaultCode(type) {
  return isKnownEventFaultType(type) ? EVENT_FAULT_CODES[type] : null;
}
var EVENT_FAULT_ENUM_ORDER = [
  "EVENT_FAULT_TYPE_UNSPECIFIED",
  "EVENT_FAULT_TYPE_UNRECOGNIZED",
  "GENERAL_NO_FURTHER_DETAILS",
  "GENERAL_INSERTION_OF_NON_VALID_CARD",
  "GENERAL_CARD_CONFLICT",
  "GENERAL_TIME_OVERLAP",
  "GENERAL_DRIVING_WITHOUT_APPROPRIATE_CARD",
  "GENERAL_CARD_INSERTION_WHILE_DRIVING",
  "GENERAL_LAST_CARD_SESSION_NOT_CORRECTLY_CLOSED",
  "GENERAL_OVER_SPEEDING",
  "GENERAL_POWER_SUPPLY_INTERRUPTION",
  "GENERAL_MOTION_DATA_ERROR",
  "GENERAL_VEHICLE_MOTION_CONFLICT",
  "GENERAL_TIME_CONFLICT_GNSS_VS_VU",
  "GENERAL_COMM_ERROR_REMOTE_COMM_FACILITY",
  "GENERAL_ABSENCE_OF_POSITION_INFO_FROM_GNSS",
  "GENERAL_COMM_ERROR_EXTERNAL_GNSS_FACILITY",
  "GENERAL_GNSS_ANOMALY",
  "VU_SEC_NO_FURTHER_DETAILS",
  "VU_SEC_MOTION_SENSOR_AUTH_FAILURE",
  "VU_SEC_TACHOGRAPH_CARD_AUTH_FAILURE",
  "VU_SEC_UNAUTHORISED_CHANGE_OF_MOTION_SENSOR",
  "VU_SEC_CARD_DATA_INPUT_INTEGRITY_ERROR",
  "VU_SEC_STORED_USER_DATA_INTEGRITY_ERROR",
  "VU_SEC_INTERNAL_DATA_TRANSFER_ERROR",
  "VU_SEC_UNAUTHORISED_CASE_OPENING",
  "VU_SEC_HARDWARE_SABOTAGE",
  "VU_SEC_TAMPER_DETECTION_OF_GNSS",
  "VU_SEC_EXTERNAL_GNSS_FACILITY_AUTH_FAILURE",
  "VU_SEC_EXTERNAL_GNSS_FACILITY_CERT_EXPIRED",
  "VU_SEC_INCONSISTENCY_MOTION_VS_ACTIVITY",
  "SENSOR_SEC_NO_FURTHER_DETAILS",
  "SENSOR_SEC_AUTHENTICATION_FAILURE",
  "SENSOR_SEC_STORED_DATA_INTEGRITY_ERROR",
  "SENSOR_SEC_INTERNAL_DATA_TRANSFER_ERROR",
  "SENSOR_SEC_UNAUTHORISED_CASE_OPENING",
  "SENSOR_SEC_HARDWARE_SABOTAGE",
  "FAULT_REC_EQ_NO_FURTHER_DETAILS",
  "FAULT_REC_EQ_VU_INTERNAL_FAULT",
  "FAULT_REC_EQ_PRINTER_FAULT",
  "FAULT_REC_EQ_DISPLAY_FAULT",
  "FAULT_REC_EQ_DOWNLOADING_FAULT",
  "FAULT_REC_EQ_SENSOR_FAULT",
  "FAULT_REC_EQ_INTERNAL_GNSS_RECEIVER",
  "FAULT_REC_EQ_EXTERNAL_GNSS_FACILITY",
  "FAULT_REC_EQ_REMOTE_COMM_FACILITY",
  "FAULT_REC_EQ_ITS_INTERFACE",
  "FAULT_REC_EQ_INTERNAL_SENSOR_FAULT",
  "FAULT_CARD_NO_FURTHER_DETAILS"
];
var TYPE_BY_CODE = new Map(
  Object.entries(EVENT_FAULT_CODES).map(
    ([name, code]) => [code, name]
  )
);
function fixGen1VuEventFaultType(type) {
  const raw = /^\d+$/.test(type) ? Number(type) : EVENT_FAULT_ENUM_ORDER.indexOf(type);
  if (raw < 0) return type;
  return TYPE_BY_CODE.get(raw) ?? type;
}

// src/utils/ddd-daily-distance.ts
var MAX_PLAUSIBLE_DAY_KM = 2e3;
var DAY_MS2 = 864e5;
function distanceFromMidnightOdometers(days, firstDayStartKm) {
  const sorted = [...days].sort((a, b) => a.date.localeCompare(b.date));
  const out = [];
  sorted.forEach((day, i) => {
    let km = null;
    if (i === 0) {
      if (firstDayStartKm !== null) km = day.odometerKm - firstDayStartKm;
    } else {
      const prev = sorted[i - 1];
      if (dayDiff(prev.date, day.date) === 1) {
        km = day.odometerKm - prev.odometerKm;
      }
    }
    if (km !== null && km >= 0 && km <= MAX_PLAUSIBLE_DAY_KM) {
      out.push({ date: day.date, km });
    }
  });
  return out;
}
function dayDiff(a, b) {
  return Math.round(
    (Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / DAY_MS2
  );
}
export {
  ALL_INDICATOR_TYPES,
  APP_LOCALE_TO_COUNTRY_LOCALE,
  AnalyticsPeriod,
  AppFeature,
  BUS_DOCUMENT_FIELD_MAP,
  COUNTRY_CODES,
  CheckpointType,
  DDD_DEFAULT_RETENTION_MONTHS,
  DEFAULT_MAX_AXLE_WEIGHT_KG,
  DEFAULT_NIGHT_WINDOW,
  DEVICE_ONLINE_THRESHOLD_MINUTES,
  DOCUMENT_EXPIRY_SOON_DAYS,
  DRIVER_CARD_DOWNLOAD_MAX_DAYS,
  DRIVER_DOCUMENT_FIELD_MAP,
  DUE_SOON_WINDOW_DAYS,
  DisplayStatus,
  DocumentEntityType,
  DocumentExpiryFilter,
  DocumentStatus,
  DocumentType,
  DriverActivityState,
  DriverScope,
  DriverStatus,
  ENTITY_DOCUMENT_TYPES,
  EU_COUNTRY_CODES,
  EVENT_FAULT_CODES,
  FEEDBACK_MESSAGE_MAX_LENGTH,
  FEEDBACK_METADATA_MAX_LENGTH,
  FUEL_ANOMALY_FEED_DAYS,
  FeedbackCategory,
  FeedbackSentiment,
  FeedbackStatus,
  FuelType,
  HEALTH_FAULT_INDICATORS,
  HOS_ETA,
  HOS_REST_NOTE_PREFIX,
  IMPERSONATION_HEADER,
  IMPERSONATION_MAX_DURATION_MS,
  INDICATOR_FIELD_MAP,
  INFRINGEMENT_SEVERITY_MAP,
  ImpersonationSessionStatus,
  IndicatorSeverity,
  IndicatorState,
  IndicatorType,
  InfringementSeverity,
  InfringementType,
  MAX_RETENTION_MONTHS,
  MIN_RETENTION_MONTHS,
  OrganizationPlan,
  OrganizationRoles,
  OrganizationStatus,
  PLAN_FEATURES,
  PlatformRole,
  RETENTION_FILE_TYPES,
  ROADWORTHINESS_DOCUMENT_TYPES,
  ROUTE_TRACKING,
  RouteStatus,
  RouteStopStatus,
  RouteVehicleProfile,
  SERVICE_DUE_SOON_KM,
  SERVICE_STALE_FACTOR,
  ScheduleApplyTarget,
  ScheduleEntityType,
  ScheduleFileType,
  ScheduleRepeat,
  ScheduleScopeType,
  TACHO_INFRINGEMENT_RULES,
  TRAILER_DOCUMENT_FIELD_MAP,
  TRUCK_DOCUMENT_FIELD_MAP,
  TachoCanWorkState,
  TachoDeviceStatus,
  TachoDownloadStatus,
  TrailerType,
  UniqueConstraintError,
  UserStatus,
  VEHICLE_DOWNLOAD_MAX_DAYS,
  VehicleStatus,
  VehicleType,
  acceptInvitationSchema,
  addTrailerSchema,
  addTruckSchema,
  applyScheduleSchema,
  applyToAllScheduleSchema,
  assessRouteHosFeasibility,
  buildDailySummaries,
  buildRouteHosFeasibility,
  calculateHosAwareEta,
  calculateRouteFormSchema,
  clampDailyRestSec,
  clampWeeklyRestSec,
  classifyDelay,
  computeProgress,
  concatPolylinePoints,
  createAdminDeviceSchema,
  createAdminOrganizationSchema,
  createAdminUserSchema,
  createDocumentSchema,
  createDriverScheduleSchema,
  createDriverSchema,
  createFeedbackSchema,
  createQuickDriverScheduleSchema,
  createQuickVehicleScheduleSchema,
  createRouteSchema,
  createVehicleScheduleSchema,
  dayLimitUsage,
  dddActivityRecordSchema,
  dddCalibrationRecordSchema,
  dddCardEventSchema,
  dddCertificateInfoSchema,
  dddControlActivitySchema,
  dddControlTypeSchema,
  dddDailyDistanceSchema,
  dddDriverCardInfoSchema,
  dddEventRecordSchema,
  dddFileKindSchema,
  dddGenerationSchema,
  dddKnownCardSchema,
  dddMetaSchema,
  dddPairedSensorSchema,
  dddParsedFileSchema,
  dddPeriodSchema,
  dddPlaceRecordSchema,
  dddSeveritySchema,
  dddSignatureSchema,
  dddSignatureStatusSchema,
  dddSpecificConditionSchema,
  dddSpeedSampleSchema,
  dddTechnicalSchema,
  dddVehicleInfoSchema,
  dddVuCardSessionSchema,
  dddVuCompanyLockSchema,
  dddVuDownloadSchema,
  dddVuInfoSchema,
  deriveDownloadStatus,
  deriveRemainingDrivingSec,
  detectGeofenceArrival,
  detectInfringements,
  distanceFromMidnightOdometers,
  driverHosFromTachoRemaining,
  editDriverScheduleSchema,
  editTrailerSchema,
  editTruckSchema,
  editVehicleScheduleSchema,
  eventFaultCode,
  fixFullCardNation,
  fixGen1VuEventFaultType,
  forgotPasswordSchema,
  getRequiredDocuments,
  getRouteDocumentInput,
  getRouteRequiredDocuments,
  haversineMeters,
  indicatorStateToSeverity,
  isDriverActivityState,
  isHealthFault,
  isIndicatorState,
  isKnownEventFaultType,
  isPilotExpired,
  isTelemetryStale,
  isUnknownNation,
  isoToFlag,
  loginSchema,
  minimumPlanForFeature,
  nationIso2,
  nationShortCode,
  parkingQuality,
  parkingVehicleClass,
  planHasFeature,
  planSecureParkingRests,
  polylineLengthM,
  positionAtDrivingTime,
  refreshTokenSchema,
  registerSchema,
  resetPasswordSchema,
  resolveNightWindow,
  retentionResponseSchema,
  routeCalcSnapshotSchema,
  routeStopSchema,
  routeTollEntrySchema,
  routeTransportMode,
  scheduleRepeatToDays,
  scoreParking,
  snapToPolyline,
  startImpersonationSchema,
  sumDailySummaries,
  updateAdminDeviceSchema,
  updateAdminOrganizationSchema,
  updateAdminUserSchema,
  updateDriverSchema,
  updateRetentionSchema,
  updateRouteSchema,
  wallClock,
  zonedEpoch
};
//# sourceMappingURL=index.mjs.map